

// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { FaRupeeSign } from "react-icons/fa";
// import { jwtDecode } from 'jwt-decode';
// import { useNavigate } from "react-router-dom"; 
// import { 
//   FiUsers, FiCalendar, FiBriefcase,  
//   FiTrendingUp, FiFileText, FiBarChart2, FiSettings,
//   FiPlus, FiUser, FiClock, FiCheckSquare, FiTarget, FiFolder, 
//   FiHome, FiMenu, FiX, FiChevronDown, 
//   FiBell,  FiMoreVertical, FiActivity, FiLock, FiTrendingDown, 
//   FiMail, FiPhone, FiMapPin
// } from "react-icons/fi";    
// import TopBar from '../../Components/TopBar';

// // Franchise Components - Same directory
// import AddEmployee from './AddEmployee';
// import DailyAttendance from './DailyAttendance';
// import ShiftManagement from './ShiftManagement';
// import AttendanceReports from './AttendanceReports';
// // import SalarySetup from './SalarySetup';
// import GenerateSalary from './GenerateSalary';
// import Policies from './Policies';
// import EmployeeDocs from './EmployeeDocs';
// import Departments from './Departments';
// import Designations from './Designations';
// import RolePermissions from './RolePermissions';
// import Companies from './Companies';
// import EmployeeReport from './EmployeeReport';
// // import Designation from './Designation';
// import LeaveRequest from './LeaveRequest';
// import LeaveApproval from './LeaveApproval';
// import Franchises from './Franchises';
// import Branch from './Branch';
// import LeaveType from './LeaveType';
// import Subscription from './Subscription';

// // Support Components - Corrected paths
// import CustomerSupport from '../../Support/Cutomer/CustomerSupport';
// import AssignTickets from '../../Support/Company/AssignTickets';
// import SupportTickets from '../../Support/employee/SupportTickets';
// import EmployeePerformance from '../../Support/Company/EmployeePerformance';

// // Task Management Components - Corrected paths
// import Tasks from '../../pages/Tasks';
// import TaskPerformance from '../../pages/TaskPerformance';

// // Project Management Components - Corrected paths
// import ProjectList from '../../ProjectManagemnet/components/ProjectList';
// import ProjectTracker from '../../ProjectManagemnet/components/ProjectTracker';
// import EmployeeLists from '../../ProjectManagemnet/components/EmployeeLists';
// import ProjectTasksManagement from '../../ProjectManagemnet/components/FollowUpTasks';
// // import MilestoneList from '../../ProjectManagemnet/components/MilestoneList'; // Hidden
// import ProjectDashboard from '../../ProjectManagemnet/pages/Dashboard';
// import Reports from '../../ProjectManagemnet/components/Reports';
// import AddProject from '../../ProjectManagemnet/components/AddProject';
// import EditProject from '../../ProjectManagemnet/components/EditProject';
// import ProjectView from '../../ProjectManagemnet/components/ProjectView';
// // import GanttChart from '../../ProjectManagemnet/pages/GanttChart'; // Hidden

// // Lead Management Components - Corrected paths
// import DashboardLead from '../../LeadMng/components/DashboardLead';

// function Dashboard({ projects = [], employees = [], milestones = [], setProjects, setMilestones }) {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [expandedMenus, setExpandedMenus] = useState({});
//   const [currentPage, setCurrentPage] = useState('Dashboard');
//   const [currentPath, setCurrentPath] = useState('/dashboard');
//   const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
//   const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);

//   // Local state for Project Management data
//   const [localProjects, setLocalProjects] = useState(projects);
//   const [localEmployees, setLocalEmployees] = useState(employees);
//   const [localMilestones, setLocalMilestones] = useState(milestones);

//   const [isDarkMode, setIsDarkMode] = useState(false);
//    const navigate = useNavigate();
//     const [logoutMessage, setLogoutMessage] = useState('');
//   // Real data state
//   const [currentUser, setCurrentUser] = useState(null);
//   const [notifications, setNotifications] = useState([]);
//   const [dashboardStats, setDashboardStats] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Company profile state
//   const [companyProfile, setCompanyProfile] = useState(null);
//   const [showCompanyProfile, setShowCompanyProfile] = useState(false);
//   const [profileLoading, setProfileLoading] = useState(false);
//   const [companyProfileError, setCompanyProfileError] = useState('');

//   // Change Password modal state
//   const [showChangePassword, setShowChangePassword] = useState(false);
//   const [changePasswordForm, setChangePasswordForm] = useState({
//     currentPassword: '',
//     newPassword: '',
//     confirmPassword: ''
//   });
//   const [changePasswordLoading, setChangePasswordLoading] = useState(false);
//   const [changePasswordError, setChangePasswordError] = useState('');
//   const [changePasswordSuccess, setChangePasswordSuccess] = useState('');

//   // API base URL
//   const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';
//   const authToken = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();

//   // Sync local state with props
//   useEffect(() => {
//     setLocalProjects(projects);
//   }, [projects]);

//   useEffect(() => {
//     setLocalEmployees(employees);
//   }, [employees]);

//   useEffect(() => {
//     setLocalMilestones(milestones);
//   }, [milestones]);


//    useEffect(() => {
//     console.log('Current path changed to:', currentPath);  // Debug log to check if path updates
//   }, [currentPath]);  // This will trigger on path change and ensure re-render

//   // Enhanced getCompanyId function that handles both company and employee logins
//   const getCompanyId = useCallback(async () => {
//     console.group('[DEBUG] getCompanyId() - Starting company ID resolution');

//     const token = localStorage.getItem('authToken');

//     if (token) {
//       try {
//         const decodedToken = jwtDecode(token);

//         // New logic based on role
//         if (decodedToken && decodedToken.role === 'company') {
//           // If role is company, use id as companyId
//           if (decodedToken.id) {
//             console.groupEnd();
//             return decodedToken.id;
//           }
//         } else {
//           // Otherwise, use companyId field if available
//           if (decodedToken && decodedToken.companyId) {
//             console.groupEnd();
//             return decodedToken.companyId;
//           }
//         }

//         // If role is not company and companyId is not present, try userId/id to fetch profile
//         if (decodedToken && (decodedToken.userId || decodedToken.id)) {
//           const userId = decodedToken.userId || decodedToken.id;
//         } else {
//           console.warn('⚠️ No userId or id found in JWT token');
//         }
//       } catch (error) {
//         console.error('❌ JWT decoding failed:', error);
//         console.warn('„ Trying alternative methods...');
//       }
//     } else {
//       console.warn('⚠️ No authToken found in localStorage');
//     }

//     // Fallback: try localStorage
//     const storedCompanyId = localStorage.getItem('companyId');
//     if (storedCompanyId) {
//       console.groupEnd();
//       return storedCompanyId;
//     } else {
//       console.warn('⚠️ No companyId found in localStorage');
//     }

//     console.error('❌ Unable to resolve company ID from any source');
//     console.groupEnd();
//     return null;
//   }, []);

//   // Updated getCurrentUserId function
//   const getCurrentUserId = useCallback(() => {
//     console.group('[DEBUG] getCurrentUserId()');

//     // Try multiple possible storage keys
//     const possibleKeys = ['userId', 'user_id', 'id', 'employeeId', 'employee_id'];
//     let userId = null;
//     let foundKey = null;

//     for (const key of possibleKeys) {
//       const value = localStorage.getItem(key);
//       if (value) {
//         userId = value.replace(/['\\\"]/g, '').trim();
//         foundKey = key;
//         break;
//       }
//     }

//     // Also try to extract from JWT token
//     if (!userId) {
//       try {
//         const token = localStorage.getItem('authToken');
//         if (token) {
//           const decoded = jwtDecode(token);
//           userId = decoded.userId || decoded.id || decoded.user?.id;
//           if (userId) {
//             foundKey = 'JWT';
//           }
//         }
//       } catch (error) {
//         console.error('❌ Failed to extract userId from JWT:', error);
//       }
//     }

//     if (!userId) {
//       console.warn('⚠️ No user ID found in localStorage or JWT');
//     } else {
//     }

//     console.groupEnd();
//     return userId;
//   }, []);

// // NEW: Helper to check if user has a specific permission
// const hasPermission = useCallback((permission) => {
//   if (currentUser?.role === 'company' || currentUser?.role === 'superadmin') {
//     return true;  // Grant full access for company or superadmin roles
//   }
//   return currentUser?.accessPermissions?.includes(permission) || false;
// }, [currentUser]);

//   // Enhanced fetchCurrentUser function using your existing utility functions
//   const fetchCurrentUser = async () => {
//     console.group('[DEBUG] fetchCurrentUser() - Starting user profile fetch');

//     try {
//       const authToken = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();

//       if (!authToken) {
//         throw new Error('No authentication token found');
//       }

//       // Decode token to get user information
//       const decodedToken = jwtDecode(authToken);

//       // Use your existing utility functions
//       const userId = getCurrentUserId();
//       const companyId = await getCompanyId();

//       let userData = null;

//       // Try multiple endpoints based on role and available data
//       if (decodedToken.role === 'company') {
//         // For company users, fetch company profile
//         try {
//           const response = await fetch(`${API_BASE_URL}/companies/${decodedToken.id}`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//           }
//         } catch (error) {
//           console.warn('⚠️ Company profile fetch failed:', error);
//         }
//       } else if (userId && decodedToken.role !== 'company') {
//         // For employee users, fetch employee profile
//         try {
//           const response = await fetch(`${API_BASE_URL}/employees/${userId}`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//           }
//         } catch (error) {
//           console.warn('⚠️ Employee profile fetch failed:', error);
//         }
//       }

//       // Fallback to the existing profile endpoint
//       if (!userData) {
//         try {
//           const response = await fetch(`${API_BASE_URL}/auth/profile`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//           }
//         } catch (error) {
//           console.warn('⚠️ Fallback profile fetch failed:', error);
//         }
//       }

//       // Set user data with enhanced information from token
//       if (userData) {
//         const enhancedUserData = {
//           ...userData,
//           id: decodedToken.id,
//           userId: userId || decodedToken.id,
//           role: decodedToken.role,
//           companyId: companyId || decodedToken.companyId,
//           accessPermissions: decodedToken.accessPermissions || [],
//           tokenData: {
//             iat: decodedToken.iat,
//             exp: decodedToken.exp,
//             isExpired: Date.now() >= decodedToken.exp * 1000
//           }
//         };

//         setCurrentUser(enhancedUserData);
//       } else {
//         throw new Error('Failed to fetch user data from all endpoints');
//       }

//     } catch (error) {
//       console.error('❌ Error in fetchCurrentUser:', error);

//       // Enhanced fallback with token data
//       try {
//         const authToken = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();
//         const decodedToken = authToken ? jwtDecode(authToken) : null;
//         const userId = getCurrentUserId();
//         const companyId = await getCompanyId();

//         const fallbackUser = {
//           id: decodedToken?.id || userId || 'unknown',
//           userId: userId || decodedToken?.id || 'unknown',
//           name: decodedToken?.role === 'company' ? 'Company Admin' : 'Admin User',
//           email: 'admin@company.com',
//           role: decodedToken?.role || 'Administrator',
//           companyId: companyId || decodedToken?.companyId || null,
//           accessPermissions: decodedToken?.accessPermissions || [],
//           avatar: null,
//           initials: decodedToken?.role === 'company' ? 'CA' : 'AU',
//           tokenData: decodedToken ? {
//             iat: decodedToken.iat,
//             exp: decodedToken.exp,
//             isExpired: Date.now() >= decodedToken.exp * 1000
//           } : null
//         };

//         setCurrentUser(fallbackUser);
//       } catch (fallbackError) {
//         console.error('❌ Fallback user creation failed:', fallbackError);
//         setCurrentUser({
//           id: 'unknown',
//           name: 'User',
//           email: 'user@company.com',
//           role: 'User',
//           avatar: null,
//           initials: 'U'
//         });
//       }
//     } finally {
//       console.groupEnd();
//     }
//   };



//   // Fetch notifications
//   const fetchNotifications = async () => {
//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();
//       const response = await fetch(`${API_BASE_URL}/notifications`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const notificationData = await response.json();
//         setNotifications(notificationData);
//       } else {
//         setNotifications([]);
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//       setNotifications([]);
//     }
//   };

//   // Fetch dashboard statistics
//   const fetchDashboardStats = async () => {
//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();

//       // Fetch multiple endpoints for dashboard stats
//       const [employeesRes, tasksRes, projectsRes, ticketsRes] = await Promise.all([
//         fetch(`${API_BASE_URL}/employees/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/tasks/stats`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/projects/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/tickets/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         })
//       ]);

//       const employeeData = employeesRes.ok ? await employeesRes.json() : { count: 0, change: 0 };
//       const taskData = tasksRes.ok ? await tasksRes.json() : { completed: 0, change: 0 };
//       const projectData = projectsRes.ok ? await projectsRes.json() : { count: 0, change: 0 };
//       const ticketData = ticketsRes.ok ? await ticketsRes.json() : { count: 0, change: 0 };

//       setDashboardStats([
//         {
//           title: "Congratulations! 🎉",
//           subtitle: "Best performance this month",
//           value: "$42.8k",
//           percentage: "78% of target 🚀",
//           bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
//           textColor: "text-white",
//           showButton: true
//         },
//         {
//           title: "Total Employees",
//           value: employeeData.count?.toString() || "0",
//           period: "Active Employees",
//           change: employeeData.change ? `${employeeData.change > 0 ? '+' : ''}${employeeData.change}%` : "+0%",
//           changeType: employeeData.change >= 0 ? "positive" : "negative",
//           icon: <FiUsers className="text-[#7367F0]" />
//         },
//         {
//           title: "Tasks Completed",
//           value: taskData.completed?.toString() || "0",
//           period: "This Month",
//           change: taskData.change ? `${taskData.change > 0 ? '+' : ''}${taskData.change}%` : "+0%",
//           changeType: taskData.change >= 0 ? "positive" : "negative",
//           icon: <FiCheckSquare className="text-[#28C76F]" />
//         },
//         {
//           title: "Total Projects",
//           value: projectData.count?.toString() || "0",
//           change: projectData.change ? `${projectData.change > 0 ? '+' : ''}${projectData.change}%` : "+0%",
//           changeType: projectData.change >= 0 ? "positive" : "negative",
//           icon: <FiFolder className="text-[#FF4560]" />
//         },
//         {
//           title: "Support Tickets",
//           value: ticketData.count?.toString() || "0",
//           change: ticketData.change ? `${ticketData.change > 0 ? '+' : ''}${ticketData.change}%` : "+0%",
//           changeType: ticketData.change >= 0 ? "positive" : "negative",
//           icon: <FiActivity className="text-[#00E396]" />
//         }
//       ]);
//     } catch (error) {
//       console.error('Error fetching dashboard stats:', error);
//       // Fallback stats
//       setDashboardStats([
//         {
//           title: "Congratulations! 🎉",
//           subtitle: "Best performance this month",
//           value: "$42.8k",
//           percentage: "78% of target 🚀",
//           bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
//           textColor: "text-white",
//           showButton: true
//         },
//         {
//           title: "Total Employees",
//           value: "0",
//           period: "Active Employees",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiUsers className="text-[#7367F0]" />
//         },
//         {
//           title: "Tasks Completed",
//           value: "0",
//           period: "This Month",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiCheckSquare className="text-[#28C76F]" />
//         },
//         {
//           title: "Total Projects",
//           value: "0",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiFolder className="text-[#FF4560]" />
//         },
//         {
//           title: "Support Tickets",
//           value: "0",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiActivity className="text-[#00E396]" />
//         }
//       ]);
//     }
//   };



// const handleLogout = useCallback(() => {

//   setLogoutMessage('Logging out...');

//   setCurrentUser(null);
//   setDashboardStats([]);
//   setNotifications([]);
//   setError(null);
//   setLoading(true);
//   localStorage.clear(); 
//   sessionStorage.clear();


//   setTimeout(() => {
//     setLogoutMessage('');
//     window.location.href = '/'; // Forces reload - UI will update to Login page
//   }, 800); 
// }, []);


//   // Token validation function
//   const validateToken = useCallback(() => {
//     try {
//       const authToken = localStorage.getItem('authToken')?.replace(/['\"]/g, '').trim();
//       if (!authToken) {
//         console.warn('⚠️ No auth token found, redirecting to login...');
//         handleLogout();
//         return false;
//       }

//       const decodedToken = jwtDecode(authToken);
//       const isExpired = Date.now() >= decodedToken.exp * 1000;

//       if (isExpired) {
//         console.warn('⚠️ Token has expired, redirecting to login...');
//         handleLogout();
//         return false;
//       }

//       return true;
//     } catch (error) {
//       console.error('❌ Token validation failed:', error);
//       handleLogout();
//       return false;
//     }
//   }, [handleLogout]);

//   // Password change handler
//   const handleChangePassword = async (e) => {
//     e.preventDefault();

//     setChangePasswordError('');
//     setChangePasswordSuccess('');

//     // Validation
//     if (!changePasswordForm.currentPassword || !changePasswordForm.newPassword || !changePasswordForm.confirmPassword) {
//       setChangePasswordError('All fields are required');
//       return;
//     }

//     if (changePasswordForm.newPassword !== changePasswordForm.confirmPassword) {
//       setChangePasswordError('New passwords do not match');
//       return;
//     }

//     if (changePasswordForm.newPassword.length < 6) {
//       setChangePasswordError('New password must be at least 6 characters long');
//       return;
//     }

//     setChangePasswordLoading(true);

//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['\\"]/g, '').trim();

//       const response = await fetch(`${API_BASE_URL}/auth/change-password`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({
//           currentPassword: changePasswordForm.currentPassword,
//           newPassword: changePasswordForm.newPassword
//         })
//       });

//       const data = await response.json().catch(() => ({}));

//       if (response.ok) {
//         setChangePasswordSuccess('Password changed successfully!');

//         setTimeout(() => {
//           setChangePasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
//           setShowChangePassword(false);
//           setChangePasswordSuccess('');
//         }, 1500);

//       } else {
//         setChangePasswordError(data.message || 'Failed to change password');
//       }

//     } catch (error) {
//       setChangePasswordError('Network error. Please try again.');
//     } finally {
//       setChangePasswordLoading(false);
//     }
//   };

//   // Input change handler
//   const handleChangePasswordInputChange = (e) => {
//     const { name, value } = e.target;
//     setChangePasswordForm(prev => ({
//       ...prev,
//       [name]: value
//     }));

//     if (changePasswordError) {
//       setChangePasswordError('');
//     }
//   };

//   // Initialize data on component mount with token validation
//   useEffect(() => {
//     const initializeData = async () => {
//       setLoading(true);

//       // Validate token first
//       if (!validateToken()) {
//         setLoading(false);
//         return;
//       }

//       try {
//         await Promise.all([
//           fetchCurrentUser(),
//           fetchNotifications(),
//           fetchDashboardStats()
//         ]);
//       } catch (error) {
//         setError('Failed to load dashboard data');
//         console.error('Error initializing dashboard:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     initializeData();

//     // Set up token validation interval
//     const tokenCheckInterval = setInterval(() => {
//       validateToken();
//     }, 60000); // Check every minute

//     // Set up polling for real-time updates
//     const dataRefreshInterval = setInterval(() => {
//       fetchNotifications();
//       fetchDashboardStats();
//     }, 30000); // Refresh every 30 seconds

//     return () => {
//       clearInterval(tokenCheckInterval);
//       clearInterval(dataRefreshInterval);
//     };
//   }, [validateToken]);

//   // Get user initials
//   const getUserInitials = (name) => {
//     if (!name) return 'U';
//     return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
//   };

//   // Toggle sidebar visibility
//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   // Toggle submenu expansion
//   const toggleMenu = (menuTitle) => {
//     setExpandedMenus(prev => ({
//       ...prev,
//       [menuTitle]: !prev[menuTitle]
//     }));
//   };

//   // Handle navigation
//  const handleNavigation = (path, title) => {
//     setCurrentPath(path);
//     // Set appropriate titles for hidden routes (as before)
//     if (path === '/add-project') {
//       setCurrentPage(title || 'Add Project');
//     } else if (path === '/edit-project') {
//       setCurrentPage(title || 'Edit Project');
//     } else if (path === '/project-view') {
//       setCurrentPage(title || 'Project Details');
//     } else if (path.startsWith('/projects/')) {
//       setCurrentPage(title || 'Project Details');
//     } else if (path.startsWith('/edit-project/')) {
//       setCurrentPage(title || 'Edit Project');
//     } else {
//       setCurrentPage(title);
//     }
//   };

// // Enhanced Company Profile Modal with all schema fields
// const renderCompanyProfileModal = () => {
//   if (!showCompanyProfile) return null;

//   const formatDate = (dateString) => {
//     if (!dateString) return 'Not specified';
//     try {
//       return new Date(dateString).toLocaleDateString('en-US', {
//         year: 'numeric',
//         month: 'long',
//         day: 'numeric'
//       });
//     } catch {
//       return 'Invalid date';
//     }
//   };

//   const renderHolidayChips = (holidays) => {
//     if (!Array.isArray(holidays) || holidays.length === 0) return <span className="text-gray-500">Not specified</span>;
//     return (
//       <div className="flex flex-wrap gap-2 mt-1">
//         {holidays.map((day, index) => (
//           <span key={index} className="px-2 py-1 bg-[#7367F0] bg-opacity-10 text-[#7367F0] rounded-md text-xs font-medium">
//             {day}
//           </span>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto shadow-2xl">
//         {/* Header */}
//         <div className="flex items-center justify-between p-6 border-b border-gray-200">
//           <h2 className="text-2xl font-bold text-[#2C2C2C] flex items-center">
//             <FiBriefcase className="mr-3 text-[#7367F0]" />
//             Company Profile
//           </h2>
//           <button
//             onClick={() => setShowCompanyProfile(false)}
//             className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//             disabled={profileLoading}
//           >
//             <FiX className="text-gray-500" />
//           </button>
//         </div>

//         {/* Loading State */}
//         {profileLoading && (
//           <div className="p-8 flex items-center justify-center">
//             <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#7367F0]"></div>
//             <span className="ml-2 text-[#6E6E6E]">Loading profile...</span>
//           </div>
//         )}

//         {/* Error State */}
//         {companyProfileError && !profileLoading && (
//           <div className="p-6">
//             <div className="bg-red-50 border border-red-200 rounded-xl p-4">
//               <p className="text-red-600">{companyProfileError}</p>
//               <button
//                 onClick={() => setShowCompanyProfile(false)}
//                 className="mt-2 text-red-600 underline text-sm"
//               >
//                 Close
//               </button>
//             </div>
//           </div>
//         )}

//         {/* Content - Only render if data is available and not loading */}
//         {!profileLoading && companyProfile && (
//           <div className="p-6 space-y-6">
//             {/* Basic Information Section */}
//             <div className="bg-gray-50 rounded-xl p-6">
//               <h3 className="text-lg font-semibold text-[#2C2C2C] mb-4 border-b border-gray-200 pb-2">
//                 Basic Information
//               </h3>
//               <div className="flex flex-col md:flex-row items-start md:items-center space-y-4 md:space-y-0 md:space-x-6">
//                 {/* Logo */}
//                 {companyProfile.businessLogo ? (
//                   <img
//                     src={companyProfile.businessLogo}
//                     alt="Business Logo"
//                     className="w-24 h-24 rounded-xl object-cover shadow-lg"
//                     onError={(e) => { e.target.style.display = 'none'; }}
//                   />
//                 ) : (
//                   <div className="w-24 h-24 bg-gradient-to-r from-[#7367F0] to-[#5A67D8] rounded-xl flex items-center justify-center shadow-lg">
//                     <span className="text-white font-bold text-2xl">
//                       {(companyProfile.businessName || 'C').charAt(0).toUpperCase()}
//                     </span>
//                   </div>
//                 )}
//                 {/* Name */}
//                 <div className="flex-1">
//                   <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Business Name</label>
//                   <p className="text-xl font-bold text-[#2C2C2C]">
//                     {companyProfile.businessName || 'Not specified'}
//                   </p>
//                 </div>
//               </div>
//             </div>

//             {/* Contact Details Section */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div className="space-y-4">
//                 <h4 className="text-lg font-semibold text-[#2C2C2C] border-b border-gray-200 pb-2">
//                   Contact Details
//                 </h4>
//                 <div className="space-y-3">
//                   <div>
//                     <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Business Email</label>
//                     <p className="text-[#2C2C2C] flex items-center">
//                       <FiMail className="mr-2 text-[#7367F0]" />
//                       {companyProfile.businessEmail || 'Not specified'}
//                     </p>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Business Phone</label>
//                     <p className="text-[#2C2C2C] flex items-center">
//                       <FiPhone className="mr-2 text-[#7367F0]" />
//                       {companyProfile.businessPhone || 'Not specified'}
//                     </p>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Emergency Mobile No</label>
//                     <p className="text-[#2C2C2C] flex items-center">
//                       <FiPhone className="mr-2 text-[#FF4560]" />
//                       {companyProfile.EmergencyMobNo || 'Not specified'}
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               <div className="space-y-4">
//                 <h4 className="text-lg font-semibold text-[#2C2C2C] border-b border-gray-200 pb-2">
//                   Address & Security
//                 </h4>
//                 <div className="space-y-3">
//                   <div>
//                     <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Address</label>
//                     <p className="text-[#2C2C2C] flex items-start">
//                       <FiMapPin className="mr-2 mt-1 text-[#7367F0] flex-shrink-0" />
//                       <span>{companyProfile.address || 'Not specified'}</span>
//                     </p>
//                   </div>
//                   <div>
//                     <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Password</label>
//                     <p className="text-[#2C2C2C] flex items-center">
//                       <FiLock className="mr-2 text-[#FF4560]" />
//                       <span className="text-gray-500">******** (Protected)</span>
//                     </p>
//                     <p className="text-xs text-gray-500 mt-1">For security, password is not displayed. Use "Change Password" to update.</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Business Details Section */}
//             <div className="space-y-4">
//               <h4 className="text-lg font-semibold text-[#2C2C2C] border-b border-gray-200 pb-2">
//                 Business Details
//               </h4>
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//                 <div>
//                   <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Created Date</label>
//                   <p className="text-[#2C2C2C]">{formatDate(companyProfile.businessCreatedDate)}</p>
//                 </div>
//                 <div>
//                   <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Subscription Plan</label>
//                   <p className="text-[#2C2C2C]">{companyProfile.businessSubscriptionPlan || 'Not specified'}</p>
//                 </div>
//                 <div className="md:col-span-2">
//                   <label className="block text-sm font-medium text-[#6E6E6E] mb-1">Weekly Holidays</label>
//                   {renderHolidayChips(companyProfile.weeklyHoliday)}
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}

//         {/* Footer */}
//         <div className="flex justify-end p-6 border-t border-gray-200">
//           <button
//             onClick={() => setShowCompanyProfile(false)}
//             className="px-6 py-2 bg-[#7367F0] text-white rounded-lg hover:bg-[#5A67D8] transition-colors disabled:opacity-50"
//             disabled={profileLoading}
//           >
//             Close
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

//   const renderChangePasswordModal = () => {
//     if (!showChangePassword) return null;

//     return (
//       <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//         <div className="bg-white rounded-2xl max-w-md w-full shadow-2xl">
//           {/* Header */}
//           <div className="flex items-center justify-between p-6 border-b border-gray-200">
//             <h2 className="text-2xl font-bold text-[#2C2C2C] flex items-center">
//               <FiLock className="mr-3 text-[#7367F0]" />
//               Change Password
//             </h2>
//             <button
//               onClick={() => {
//                 setShowChangePassword(false);
//                 setChangePasswordForm({ currentPassword: '', newPassword: '', confirmPassword: '' });
//                 setChangePasswordError('');
//                 setChangePasswordSuccess('');
//               }}
//               className="p-2 hover:bg-gray-100 rounded-full transition-colors"
//             >
//               <FiX className="text-gray-500" />
//             </button>
//           </div>

//           {/* Form */}
//           <form onSubmit={handleChangePassword} className="p-6 space-y-4">
//             {/* Error/Success Messages */}
//             {changePasswordError && (
//               <div className="bg-red-50 border border-red-200 rounded-lg p-3">
//                 <p className="text-red-600 text-sm">{changePasswordError}</p>
//               </div>
//             )}

//             {changePasswordSuccess && (
//               <div className="bg-green-50 border border-green-200 rounded-lg p-3">
//                 <p className="text-green-600 text-sm flex items-center">
//                   <FiCheckSquare className="mr-2" />
//                   {changePasswordSuccess}
//                 </p>
//               </div>
//             )}

//             {/* Current Password Field */}
//             <div>
//               <label className="block text-sm font-medium text-[#2C2C2C] mb-2">Current Password *</label>
//               <div className="relative">
//                 <input
//                   type="password"
//                   name="currentPassword"
//                   value={changePasswordForm.currentPassword}
//                   onChange={handleChangePasswordInputChange}
//                   placeholder="Enter your current password"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#7367F0] focus:border-transparent transition-colors"
//                   required
//                   disabled={changePasswordLoading}
//                 />
//                 <FiLock className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               </div>
//             </div>

//             {/* New Password Field */}
//             <div>
//               <label className="block text-sm font-medium text-[#2C2C2C] mb-2">New Password *</label>
//               <div className="relative">
//                 <input
//                   type="password"
//                   name="newPassword"
//                   value={changePasswordForm.newPassword}
//                   onChange={handleChangePasswordInputChange}
//                   placeholder="Enter your new password (min. 6 characters)"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#7367F0] focus:border-transparent transition-colors"
//                   required
//                   minLength="6"
//                   disabled={changePasswordLoading}
//                 />
//                 <FiLock className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               </div>
//             </div>

//             {/* Confirm Password Field */}
//             <div>
//               <label className="block text-sm font-medium text-[#2C2C2C] mb-2">Confirm New Password *</label>
//               <div className="relative">
//                 <input
//                   type="password"
//                   name="confirmPassword"
//                   value={changePasswordForm.confirmPassword}
//                   onChange={handleChangePasswordInputChange}
//                   placeholder="Confirm your new password"
//                   className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#7367F0] focus:border-transparent transition-colors"
//                   required
//                   disabled={changePasswordLoading}
//                 />
//                 <FiCheckSquare className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               </div>
//             </div>

//             {/* Action Buttons */}
//             <div className="flex space-x-3 pt-4">
//               <button
//                 type="button"
//                 onClick={() => setShowChangePassword(false)}
//                 className="flex-1 px-4 py-3 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors font-medium"
//                 disabled={changePasswordLoading}
//               >
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="flex-1 px-4 py-3 bg-[#7367F0] text-white rounded-lg hover:bg-[#5A67D8] transition-colors font-medium flex items-center justify-center disabled:opacity-50"
//                 disabled={changePasswordLoading}
//               >
//                 {changePasswordLoading ? (
//                   <>
//                     <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
//                     Changing...
//                   </>
//                 ) : (
//                   <>
//                     <FiCheckSquare className="mr-2" />
//                     Change Password
//                   </>
//                 )}
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//     );
//   };

//   // Menu data organized by category
//  const menuCategories = useMemo(() => {
//     console.log('Current User Permissions:', currentUser?.accessPermissions);

//   const employeePermissions = ['list_teammember', 'create_teammember', 'update_teammember', 'delete_teammember'];
//   const hasAnyEmployeePermission = employeePermissions.some(perm => hasPermission(perm));

//   // Only include "Employee Management" if user is company/superadmin or has any employee permission
//   const employeeManagementCategory = (currentUser?.role === 'company' || currentUser?.role === 'superadmin' || hasAnyEmployeePermission) ? [
//     {
//       title: "Employee Management",
//       icon: <FiUsers className="text-xl" />,
//       submenus: [
//         { path: "/add-employee", title: "Add Employee", icon: <FiPlus /> },
//          ...(hasPermission('employee_report') ? [{ path: "/employee-report", title: "Employee Report", icon: <FiUsers /> }] : []),
//       ]
//     }
//   ] : [];

//   return [
//     {
//       title: "Dashboard",
//       icon: <FiHome className="text-xl" />,
//       path: "/dashboard",
//       submenus: []
//     },
//     ...employeeManagementCategory,  // Conditionally added here
//     {
//       title: "Attendance",
//       icon: <FiCalendar className="text-xl" />,
//       submenus: [
//          ...(hasPermission('daily_attendance') ? [{ path: "/daily-attendance", title: "Daily Attendance", icon: <FiClock /> }] : []),
//         ...( !['company', 'franchise', 'superadmin'].includes(currentUser?.role) 
//           ? [] 
//           : [
//               ...(hasPermission('settings_shift') ? [{ path: "/shift-management", title: "Shift Management", icon: <FiCheckSquare /> }] : []),
//              ...(hasPermission('attendance_report') ? [{ path: "/attendance-reports", title: "Attendance Reports", icon: <FiBarChart2 /> }] : []),


//             ]
//         )
//       ]
//     },
//     {
//       title: "Leaves",
//       icon: <FiBriefcase className="text-xl" />,
//       submenus: [
//         ...(hasPermission('leave_request') ? [{ path: "/leave-request", title: "Leave Request", icon: <FiPlus /> }] : []),
//         ...(hasPermission('leave_approval') ? [{ path: "/leave-approval", title: "Leave Approval", icon: <FiCheckSquare /> }] : []),
//         ...(hasPermission('leave_type') ? [{ path: "/leave-type", title: "Leave Type", icon: <FiFileText /> }] : [])
//       ].filter(Boolean)
//     },
//     {
//       title: "Payroll",
//       icon: <FaRupeeSign className="text-xl" />,
//       submenus: [
//          ...(hasPermission('salary_generation') ? [{ path: "/generate-salary", title: "Generate Salary", icon: <FaRupeeSign /> }] : []),
//       ]
//     },
//     {
//       title: "Support",
//       icon: <FiSettings className="text-xl" />,
//       submenus: [
//         ...(hasPermission('customer_support') ? [{ path: "/customer-support", title: "Customer Support", icon: <FiUsers /> }] : []),
//         ...(hasPermission('com_tickets') ? [{ path: "/com-tickets", title: "Company Tickets", icon: <FiUser /> }] : []),
//         ...(hasPermission('employee_performance') ? [{ path: "/employee-performance", title: "Employee Performance", icon: <FiUser /> }] : []),
//       ]
//     },
//     {
//       title: "Task Management",
//       icon: <FiTarget className="text-xl" />,
//       submenus: [
//         { path: "/tasks", title: "Tasks", icon: <FiCheckSquare /> },
//           ...(hasPermission('task_performance') ? [{ path: "/TaskPerformance", title: "Task Performance", icon: <FiCheckSquare /> }] : []),

//       ]
//     },
//     {
//       title: "Lead Management",
//       icon: <FiTarget className="text-xl" />,
//       submenus: [
//          ...(hasPermission('lead_management') ? [{ path: "/lead-mng", title: "Lead Management", icon: <FiTarget /> }] : []),

//       ]
//     },   
//       {
//         title: "Project Management",
//         icon: <FiBriefcase className="text-xl" />,
//         submenus: [
//           ...(hasPermission('project_dashboard') ? [{ path: "/dashboard-projectmgnt", title: "Projects Dashboard", icon: <FiBarChart2 /> }] : []),
//           ...(hasPermission('projects') ? [{ path: "/projects", title: "Projects", icon: <FiFolder /> }] : []),  // Ensure this is included
//           ...(hasPermission('project_employee_lists') ? [{ path: "/employees", title: "Employee Lists", icon: <FiUsers /> }] : []),
//           ...(hasPermission('project_tracker') ? [{ path: "/kanban", title: "Project Tracker", icon: <FiTarget /> }] : []),
//           ...(hasPermission('project_tasks') ? [{ path: "/project-tasks", title: "Project-Tasks", icon: <FiClock /> }] : []),
//           ...(hasPermission('project_reports') ? [{ path: "/reports", title: "Reports", icon: <FiFileText /> }] : []),
//         ].filter(Boolean)  // Keep filtering empty submenus
//       },
//     {
//       title: "Settings",
//       icon: <FiSettings className="text-xl" />,
//       submenus: (() => {
//         const baseSubmenus = [
//           { path: "/departments", title: "Departments", icon: <FiUsers /> },
//           { path: "/designations", title: "Designations", icon: <FiUser /> },
//           { path: "/role-permissions", title: "Role Permissions", icon: <FiSettings /> }
//         ];
//         const adminOnlySubmenus = [
//           { path: "/companies", title: "Companies", icon: <FiBriefcase /> },
//           { path: "/franchises", title: "Franchises", icon: <FiSettings /> },
//           { path: "/branch", title: "Branch", icon: <FiSettings /> },
//           { path: "/subscription", title: "Subscription", icon: <FiSettings /> }
//         ];
//         const isAdmin = currentUser && ['superadmin', 'franchise'].includes(currentUser.role);
//         return isAdmin ? [...baseSubmenus, ...adminOnlySubmenus] : baseSubmenus;
//       })()
//     }
//   ].filter(category => category.submenus.length > 0 || category.path);  // Existing filter
// }, [currentUser, hasPermission]);

//   // Main dashboard content with real data
//   const renderDashboardContent = () => (
//     <div className="space-y-6">
//       {/* Loading State */}
//       {loading && (
//         <div className="flex items-center justify-center py-12">
//           <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#7367F0]"></div>
//           <span className="ml-2 text-[#6E6E6E]">Loading dashboard data...</span>
//         </div>
//       )}

//       {/* Error State */}
//       {error && (
//         <div className="bg-red-50 border border-red-200 rounded-xl p-4">
//           <p className="text-red-600">{error}</p>
//         </div>
//       )}

//       {/* Stats Grid */}
//       {!loading && (
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
//           {dashboardStats.map((stat, index) => (
//             <div key={index} className={`rounded-2xl p-6 ${stat.bgColor || 'bg-white'} shadow-sm hover:shadow-lg transition-shadow`}>
//               {stat.showButton ? (
//                 <>
//                   <div className="flex items-center justify-between mb-4">
//                     <div className={stat.textColor}>
//                       <h3 className="text-lg font-semibold">{stat.title}</h3>
//                       <p className="text-sm opacity-90">{stat.subtitle}</p>
//                     </div>
//                   </div>
//                   <div className={`mb-4 ${stat.textColor}`}>
//                     <div className="text-3xl font-bold">{stat.value}</div>
//                     <div className="text-sm opacity-90">{stat.percentage}</div>
//                   </div>
//                   <button className="bg-white bg-opacity-20 hover:bg-opacity-30 text-white px-4 py-2 rounded-lg transition-all">
//                     View Details
//                   </button>
//                 </>
//               ) : (
//                 <>
//                   <div className="flex items-center justify-between mb-4">
//                     {stat.icon && (
//                       <div className="p-3 rounded-xl bg-gray-50">
//                         {stat.icon}
//                       </div>
//                     )}
//                     <button className="text-[#9E9E9E] hover:text-[#6E6E6E]">
//                       <FiMoreVertical />
//                     </button>
//                   </div>
//                   <div className="space-y-2">
//                     <h3 className="text-[#6E6E6E] text-sm font-medium">{stat.title}</h3>
//                     <div className="text-2xl font-bold text-[#2C2C2C]">{stat.value}</div>
//                     {stat.period && (
//                       <p className="text-xs text-[#9E9E9E]">{stat.period}</p>
//                     )}
//                     {stat.change && (
//                       <div className={`flex items-center text-sm ${
//                         stat.changeType === 'positive' ? 'text-[#28C76F]' : 'text-[#FF4560]'
//                       }`}>
//                         {stat.changeType === 'positive' ? <FiTrendingUp className="mr-1" /> : <FiTrendingDown className="mr-1" />}
//                         {stat.change}
//                       </div>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Quick Actions Grid */}
//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
//         <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all cursor-pointer border border-transparent hover:border-[#7367F0]" 
//              onClick={() => handleNavigation('/add-employee', 'Add Employee')}>
//           <div className="flex items-center space-x-4">
//             <div className="p-3 bg-[#7367F0] bg-opacity-10 rounded-xl">
//               <FiPlus className="text-[#7367F0] text-xl" />
//             </div>
//             <div>
//               <h3 className="font-semibold text-[#2C2C2C]">Add Employee</h3>
//               <p className="text-sm text-[#6E6E6E]">Register new employee</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all cursor-pointer border border-transparent hover:border-[#00E396]" 
//              onClick={() => handleNavigation('/tasks', 'Tasks')}>
//           <div className="flex items-center space-x-4">
//             <div className="p-3 bg-[#00E396] bg-opacity-10 rounded-xl">
//               <FiCheckSquare className="text-[#00E396] text-xl" />
//             </div>
//             <div>
//               <h3 className="font-semibold text-[#2C2C2C]">Manage Tasks</h3>
//               <p className="text-sm text-[#6E6E6E]">View and assign tasks</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all cursor-pointer border border-transparent hover:border-[#FEB019]" 
//              onClick={() => handleNavigation('/daily-attendance', 'Daily Attendance')}>
//           <div className="flex items-center space-x-4">
//             <div className="p-3 bg-[#FEB019] bg-opacity-10 rounded-xl">
//               <FiClock className="text-[#FEB019] text-xl" />
//             </div>
//             <div>
//               <h3 className="font-semibold text-[#2C2C2C]">Mark Attendance</h3>
//               <p className="text-sm text-[#6E6E6E]">Daily attendance tracking</p>
//             </div>
//           </div>
//         </div>

//         <div className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all cursor-pointer border border-transparent hover:border-[#775DD0]" 
//              onClick={() => handleNavigation('/projects', 'Projects')}>
//           <div className="flex items-center space-x-4">
//             <div className="p-3 bg-[#775DD0] bg-opacity-10 rounded-xl">
//               <FiFolder className="text-[#775DD0] text-xl" />
//             </div>
//             <div>
//               <h3 className="font-semibold text-[#2C2C2C]">View Projects</h3>
//               <p className="text-sm text-[#6E6E6E]">Manage all projects</p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Recent Activities & Analytics */}
//       <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
//         {/* Recent Activities */}
//         <div className="bg-white rounded-2xl shadow-sm p-6">
//           <h2 className="text-xl font-semibold text-[#2C2C2C] mb-4">Recent Activities</h2>
//           <ul className="space-y-3">
//             <li className="flex items-center p-3 hover:bg-gray-50 rounded-lg transition-colors">
//               <div className="bg-green-100 p-2 rounded-full mr-3">
//                 <FiUser className="text-green-500" />
//               </div>
//               <div>
//                 <p className="text-sm font-medium text-[#2C2C2C]">New employee added to Engineering dept</p>
//                 <p className="text-xs text-[#6E6E6E]">2 hours ago</p>
//               </div>
//             </li>
//             <li className="flex items-center p-3 hover:bg-gray-50 rounded-lg transition-colors">
//               <div className="bg-blue-100 p-2 rounded-full mr-3">
//                 <FiCheckSquare className="text-blue-500" />
//               </div>
//               <div>
//                 <p className="text-sm font-medium text-[#2C2C2C]">Task 'Website Redesign' completed</p>
//                 <p className="text-xs text-[#6E6E6E]">5 hours ago</p>
//               </div>
//             </li>
//             <li className="flex items-center p-3 hover:bg-gray-50 rounded-lg transition-colors">
//               <div className="bg-purple-100 p-2 rounded-full mr-3">
//                 <FiBriefcase className="text-purple-500" />
//               </div>
//               <div>
//                 <p className="text-sm font-medium text-[#2C2C2C]">Leave request approved for John Doe</p>
//                 <p className="text-xs text-[#6E6E6E]">Yesterday, 4:15 PM</p>
//               </div>
//             </li>
//           </ul>
//         </div>

//         {/* System Overview */}
//         <div className="bg-white rounded-2xl shadow-sm p-6">
//           <h2 className="text-xl font-semibold text-[#2C2C2C] mb-4">System Overview</h2>
//           <div className="space-y-4">
//             <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 bg-[#7367F0] bg-opacity-20 rounded-full flex items-center justify-center">
//                   <FiUsers className="text-[#7367F0] text-sm" />
//                 </div>
//                 <span className="text-sm font-medium text-[#2C2C2C]">Active Users</span>
//               </div>
//               <span className="text-sm font-bold text-[#2C2C2C]">
//                 {dashboardStats.find(stat => stat.title === 'Total Employees')?.value || '0'}
//               </span>
//             </div>
//             <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 bg-[#00E396] bg-opacity-20 rounded-full flex items-center justify-center">
//                   <FiCheckSquare className="text-[#00E396] text-sm" />
//                 </div>
//                 <span className="text-sm font-medium text-[#2C2C2C]">Pending Tasks</span>
//               </div>
//               <span className="text-sm font-bold text-[#2C2C2C]">
//                 {dashboardStats.find(stat => stat.title === 'Tasks Completed')?.value || '0'}
//               </span>
//             </div>
//             <div className="flex items-center justify-between p-3 bg-gray-50 rounded-lg">
//               <div className="flex items-center space-x-3">
//                 <div className="w-8 h-8 bg-[#FF4560] bg-opacity-20 rounded-full flex items-center justify-center">
//                   <FiActivity className="text-[#FF4560] text-sm" />
//                 </div>
//                 <span className="text-sm font-medium text-[#2C2C2C]">Open Tickets</span>
//               </div>
//               <span className="text-sm font-bold text-[#2C2C2C]">
//                 {dashboardStats.find(stat => stat.title === 'Support Tickets')?.value || '0'}
//               </span>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );

//   // Route to different pages based on currentPath (keeping the same as before)
//   const renderPageContent = () => {
//     // Extract base path without query parameters for routing
// const safeCurrentPath = currentPath || '/dashboard';  // Fallback to default path
//   const basePath = safeCurrentPath.split('?')[0];  

//     switch (basePath) {
//       case '/dashboard':
//         return renderDashboardContent();

//       // Employee Management
//       case '/add-employee':
//         return <AddEmployee />;

//       case '/employee-report':
//         return <EmployeeReport />;

//       // Attendance
//       case '/daily-attendance':
//         return <DailyAttendance />;
//       case '/shift-management':
//         return <ShiftManagement />;
//       case '/attendance-reports':
//         return <AttendanceReports />;

//       // Leaves
//       case '/leave-request':
//         return <LeaveRequest />;
//       case '/leave-approval':
//         return <LeaveApproval />;
//       case '/leave-type':
//         return <LeaveType />;

//       // Payroll
//       // case '/salary-setup':
//       //   return <SalarySetup />;
//       case '/generate-salary':
//         return <GenerateSalary />;

//       // Documents & Policies
//       case '/policies':
//         return <Policies />;
//       case '/employee-docs':
//         return <EmployeeDocs />;

//       // Support
//       case '/customer-support':
//         return <CustomerSupport />;
//       case '/com-tickets':
//         return <AssignTickets />;
//       case '/sup-tickets':
//         return <SupportTickets />;
//       case '/employee-performance':
//         return <EmployeePerformance />;

//       // Task Management
//       case '/tasks':
//         return <Tasks />;
//       case '/TaskPerformance':
//         return <TaskPerformance />;


//       // Lead Management
//       case '/lead-mng':
//         return <DashboardLead />;

//       // Project Management
//     case '/dashboard-projectmgnt':
//         return <ProjectDashboard projects={projects} employees={employees} milestones={milestones} onNavigate={handleNavigation} />;

//       case '/projects':
//         return <ProjectList projects={projects} setProjects={setProjects} onNavigate={handleNavigation} />;

//       case '/add-project':
//         return <AddProject projects={projects} setProjects={setProjects} onNavigate={handleNavigation} />;

//       case '/edit-project':
//         return <EditProject projects={projects} setProjects={setProjects} onNavigate={handleNavigation} />;

//       case '/project-view':
//         return <ProjectView projects={projects} employees={employees} milestones={milestones} onNavigate={handleNavigation} />;

//       case '/employees':
//         return <EmployeeLists onNavigate={handleNavigation} />;

//       // Hidden routes - can be enabled later if needed

//       case '/kanban':
//         return <ProjectTracker projects={localProjects} setProjects={setLocalProjects} milestones={localMilestones} setMilestones={setLocalMilestones} onNavigate={handleNavigation} />;
//       case '/project-tasks':
//         return <ProjectTasksManagement onNavigate={handleNavigation} />;
//       // case '/gantt':
//       //   return <GanttChart />;
//       case '/reports':
//         return <Reports projects={localProjects} employees={localEmployees} milestones={localMilestones} />;

//       // Settings
//       case '/departments':
//         return <Departments />;
//       case '/designations':
//         return <Designations />;
//       // case '/designation':
//       //   return <Designation />;
//       case '/role-permissions':
//         return <RolePermissions />;
//       case '/companies':
//         return <Companies />;
//       case '/franchises':
//         return <Franchises />;
//       case '/branch':
//         return <Branch />;
//       case '/subscription':
//         return <Subscription />;

//       default:
//         if (basePath.startsWith('/projects/')) {
//           const projectId = basePath.split('/projects/')[1];
//           return <ProjectView projects={projects} employees={employees} milestones={milestones} onNavigate={handleNavigation} projectId={projectId} />;
//         }
//         if (basePath.startsWith('/edit-project/')) {
//           const projectId = basePath.split('/edit-project/')[1];
//           return <EditProject projects={projects} setProjects={setProjects} onNavigate={handleNavigation} projectId={projectId} />;
//         }
//         return renderDashboardContent();
//     }
//   };

//   // Click outside handler to close dropdowns
//   React.useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isProfileDropdownOpen || isNotificationDropdownOpen) {
//         setIsProfileDropdownOpen(false);
//         setIsNotificationDropdownOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isProfileDropdownOpen, isNotificationDropdownOpen]);

//   return (
//     <div className="flex h-screen bg-[#F8F9FA]">
//       {/* Sidebar - Dark Theme */}
//       <div className={`bg-[#282a42] shadow-2xl transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-20'} border-r border-[#30334e] z-50`}>
//         {/* Header */}
//         <div className="flex items-center justify-between p-4 border-b border-[#30334e]">
//           {isSidebarOpen && (
//             <div className="flex items-center space-x-2">
//               <div className="w-8 h-8 bg-[#7367F0] rounded-lg flex items-center justify-center shadow-lg">
//                 <span className="text-white font-bold text-sm">H</span>
//               </div>
//               <h1 className="text-xl font-bold text-[#d7d8ee]">CRM</h1>
//             </div>
//           )}
//           <button 
//             onClick={toggleSidebar} 
//             className="p-2 rounded-lg hover:bg-[#30334e] transition-all duration-200 text-[#d7d8ee] hover:text-white"
//           >
//             {isSidebarOpen ? <FiX /> : <FiMenu />}
//           </button>
//         </div>

//         {/* Navigation */}
//         <nav className="mt-4 px-4 pb-4 overflow-y-auto max-h-[calc(100vh-180px)] custom-scrollbar">
//           <div className="space-y-1">
//             {menuCategories.map((category, index) => (
//               <div key={index} className="mb-1">
//                 {category.submenus.length > 0 ? (
//                   <>
//                     {/* Parent Menu with Submenus */}
//                     <button
//                       onClick={() => toggleMenu(category.title)}
//                       className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${
//                         expandedMenus[category.title] 
//                           ? 'bg-[#7367F0] text-white shadow-lg' 
//                           : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                       }`}
//                     >
//                       <span className={`mr-3 transition-colors duration-200 ${
//                         expandedMenus[category.title] ? 'text-white' : 'text-[#b8b9d4]'
//                       }`}>
//                         {category.icon}
//                       </span>

//                       {isSidebarOpen && (
//                         <>
//                           <span className="flex-1 text-left font-medium text-sm">
//                             {category.title}
//                           </span>
//                           <span className={`text-sm transition-transform duration-200 ${
//                             expandedMenus[category.title] ? 'rotate-180' : ''
//                           }`}>
//                             <FiChevronDown />
//                           </span>
//                         </>
//                       )}

//                       {expandedMenus[category.title] && (
//                         <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
//                       )}
//                     </button>

//                     {/* Submenu Items */}
//                     {isSidebarOpen && expandedMenus[category.title] && (
//                       <div className="pl-4 mt-2 space-y-1">
//                         {category.submenus.map((submenu, subIndex) => (
//                           <button
//                             key={subIndex}
//                             onClick={() => handleNavigation(submenu.path, submenu.title)}
//                             className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl text-sm group ${
//                               currentPath === submenu.path 
//                                 ? 'bg-[#3b3d57] text-white shadow-md border-l-2 border-[#7367F0]' 
//                                 : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                             }`}
//                           >
//                             <span className={`mr-3 text-sm transition-colors duration-200 ${
//                               currentPath === submenu.path ? 'text-[#7367F0]' : 'text-[#b8b9d4]'
//                             }`}>
//                               {submenu.icon}
//                             </span>
//                             <span className="font-medium">{submenu.title}</span>

//                             {currentPath === submenu.path && (
//                               <div className="ml-auto w-2 h-2 bg-[#7367F0] rounded-full"></div>
//                             )}
//                           </button>
//                         ))}
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                         category.path && (  

//                   <button
//                     onClick={() => handleNavigation(category.path, category.title)}
//                     className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${
//                       currentPath === category.path 
//                         ? 'bg-[#7367F0] text-white shadow-lg' 
//                         : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                     }`}
//                   >
//                     <span className={`mr-3 transition-colors duration-200 ${
//                       currentPath === category.path ? 'text-white' : 'text-[#b8b9d4]'
//                     }`}>
//                       {category.icon}
//                     </span>

//                     {isSidebarOpen && (
//                       <span className="font-medium text-sm">{category.title}</span>
//                     )}

//                     {currentPath === category.path && (
//                       <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
//                     )}
//                   </button>
//                         )
//                 )}
//               </div>
//             ))}
//           </div>
//         </nav>
//       </div>

//       {/* Main Content Area */}
//       <div className="flex-1 flex flex-col overflow-hidden">
//         {/* Topbar */}
//           <TopBar 
//                 currentPage={currentPage}
//                 currentUser={currentUser}
//                 isProfileDropdownOpen={isProfileDropdownOpen}
//                 setIsProfileDropdownOpen={setIsProfileDropdownOpen}
//                 onLogout={handleLogout}
//                 getUserInitials={getUserInitials}
//               />

//         {/* Page Content */}
//         <div className="flex-1 overflow-auto p-6">
//           {renderPageContent()}
//         </div>
//       </div>

//       {/* Company Profile Modal */}
//       {renderCompanyProfileModal()}
//       {renderChangePasswordModal()}
//     </div>
//   );
// }

// export default Dashboard;













































// import React, { useState, useEffect, useCallback, useMemo } from "react";
// import { FaRupeeSign } from "react-icons/fa";
// import { jwtDecode } from 'jwt-decode';
// import { useNavigate } from "react-router-dom"; 
// import { 
//   FiUsers, FiCalendar, FiBriefcase, FiDollarSign, 
//   FiTrendingUp, FiFileText, FiBarChart2, FiSettings,
//   FiPlus, FiList, FiUser, FiClock, FiCheckSquare,
//   FiDownload, FiTarget, FiFile, FiFolder, FiAward,
//   FiHome, FiMenu, FiX, FiChevronDown, FiChevronRight,
//   FiBell, FiSearch, FiMoreVertical, FiActivity,
//   FiShoppingCart, FiLock, FiTrendingDown, FiLogOut,
//   FiMail, FiPhone, FiMapPin, FiSun, FiMoon, FiMaximize2
// } from "react-icons/fi";
// import axios from 'axios';  // For API calls (or use fetch)

// // Franchise Components - Same directory
// import AddEmployee from './AddEmployee';
// import DailyAttendance from './DailyAttendance';
// import ShiftManagement from './ShiftManagement';
// import AttendanceReports from './AttendanceReports';
// import SalaryAdvance from './SalaryAdvance';
// import GenerateSalary from './GenerateSalary';
// import Policies from './Policies';
// import EmployeeDocs from './EmployeeDocs';
// import Departments from './Departments';
// import Designations from './Designations';
// // import RolePermissions from './RolePermissions';
// import Companies from './Companies';
// import EmployeeReport from './EmployeeReport';
// // import Designation from './Designation';
// import LeaveRequest from './LeaveRequest';
// import LeaveApproval from './LeaveApproval';
// import Franchise from './Franchises';
// import Branch from './Branch';
// import LeaveType from './LeaveType';
// import Subscription from './Subscription';
// // Support Components - Corrected paths
// import CustomerSupport from '../../Support/Cutomer/CustomerSupport';
// import AssignTickets from '../../Support/Company/AssignTickets';
// import SupportTickets from '../../Support/employee/SupportTickets';
// import EmployeePerformance from '../../Support/Company/EmployeePerformance';

// // Task Management Components - Corrected paths
// import Tasks from '../../pages/Tasks';
// import TaskPerformance from '../../pages/TaskPerformance';

// // Project Management Components - Corrected paths
// import ProjectList from '../../ProjectManagemnet/components/ProjectList';
// import ProjectTracker from '../../ProjectManagemnet/components/ProjectTracker';
// import EmployeeLists from '../../ProjectManagemnet/components/EmployeeLists';
// import MilestoneList from '../../ProjectManagemnet/components/MilestoneList';
// import ProjectDashboard from '../../ProjectManagemnet/pages/Dashboard';
// import Reports from '../../ProjectManagemnet/components/Reports';
// import AddProject from '../../ProjectManagemnet/components/AddProject'; 
// import ProjectTasksManagement from '../../ProjectManagemnet/components/FollowUpTasks';

// // Lead Management Components - Corrected paths
// import DashboardLead from '../../LeadMng/components/DashboardLead';
// import ProjectView from '../../ProjectManagemnet/components/ProjectView';
// // Import the new TopBar component
// import TopBar from '../../Components/TopBar'
// import ComprehensiveDashboard from "../../Components/DashAll/ComprehensiveDashboard";

// function FranchiseDashboard({ projects: propProjects, employees, milestones,  setProjects: propSetProjects, setMilestones }) {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [expandedMenus, setExpandedMenus] = useState({});
//   const [currentPage, setCurrentPage] = useState('Dashboard');
//   const [currentPath, setCurrentPath] = useState('/dashboard');
//   const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
//   const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
//   const [previousPath, setPreviousPath] = useState('/comprehensivedashboard');  // Default to dashboard

//   const navigate = useNavigate();
//   const [logoutMessage, setLogoutMessage] = useState('');

//   // Real data state
//   const [currentUser, setCurrentUser] = useState(null);
//   const [notifications, setNotifications] = useState([]);
//   const [dashboardStats, setDashboardStats] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // API base URL
//   const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';
//   const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//   const [localProjects, setLocalProjects] = useState(propProjects || []);


//   // Function to fetch projects (similar to ProjectList's fetchProjects)
//   const fetchProjects = async () => {
//     try {
//       console.log('Dashboard - fetchProjects called');
//       const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//       if (!token) {
//         console.error('No access token found');
//         return;
//       }
//       const response = await axios.get(`${API_BASE_URL}/projectsmgnt`, {
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json'
//         }
//       });
//       if (response.status === 200) {
//         const data = response.data;
//         console.log('Dashboard - Fetched projects:', data.length, 'projects');
//         setLocalProjects(data);
//         if (propSetProjects) propSetProjects(data);  // Sync with parent if needed
//       } else {
//         console.error('Failed to fetch projects:', response.status);
//       }
//     } catch (error) {
//       console.error('Error fetching projects in Dashboard:', error);
//     }
//   };

//     // Fetch projects on mount if localProjects is empty
//   useEffect(() => {
//     if (!localProjects || localProjects.length === 0) {
//       fetchProjects();
//     }
//   }, []);  // Run once on mount

//     // Update localProjects if prop changes (e.g., from App.js)
//   useEffect(() => {
//     if (propProjects && propProjects.length > 0) {
//       setLocalProjects(propProjects);
//     }
//   }, [propProjects]);



//   // Utility functions
//   const getCompanyId = useCallback(async () => {
//     console.group('[DEBUG] getCompanyId() - Starting company ID resolution');

//     const token = localStorage.getItem('authToken');
//     console.log('📋 Token from localStorage:', token ? `${token.substring(0, 50)}...` : 'null');

//     if (token) {
//       try {
//         console.log(' Attempting to decode JWT token...');
//         const decodedToken = jwtDecode(token);
//         console.log('📊 Decoded token structure:', JSON.stringify(decodedToken, null, 2));

//         if (decodedToken && decodedToken.role === 'company') {
//           if (decodedToken.id) {
//             console.groupEnd();
//             return decodedToken.id;
//           }
//         } else {
//           if (decodedToken && decodedToken.companyId) {
//             console.groupEnd();
//             return decodedToken.companyId;
//           }
//         }

//         if (decodedToken && (decodedToken.userId || decodedToken.id)) {
//           const userId = decodedToken.userId || decodedToken.id;
//           console.log('Employee ID from JWT:', userId);
//           console.log('„ Attempting to fetch employee profile from MongoDB...');
//         } else {
//           console.warn('⚠️ No userId or id found in JWT token');
//           console.log('Token payload keys available:', Object.keys(decodedToken || {}));
//         }
//       } catch (error) {
//         console.error('❌ JWT decoding failed:', error);
//         console.warn('„ Trying alternative methods...');
//       }
//     } else {
//       console.warn('⚠️ No authToken found in localStorage');
//       console.log('📋 All localStorage keys:', Object.keys(localStorage));
//     }

//     const storedCompanyId = localStorage.getItem('companyId');
//     if (storedCompanyId) {
//       console.log('✅ Found companyId in localStorage:', storedCompanyId);
//       console.groupEnd();
//       return storedCompanyId;
//     } else {
//       console.warn('⚠️ No companyId found in localStorage');
//     }

//     console.error('❌ Unable to resolve company ID from any source');
//     console.groupEnd();
//     return null;
//   }, []);

//   const getCurrentUserId = useCallback(() => {
//     console.group('[DEBUG] getCurrentUserId()');

//     const possibleKeys = ['userId', 'user_id', 'id', 'employeeId', 'employee_id'];
//     let userId = null;
//     let foundKey = null;

//     for (const key of possibleKeys) {
//       const value = localStorage.getItem(key);
//       if (value) {
//         userId = value.replace(/['"]/g, '').trim();
//         foundKey = key;
//         console.log(`✅ Found userId with key '${key}':`, userId);
//         break;
//       }
//       console.log(`❌ No value for key '${key}'`);
//     }

//     if (!userId) {
//       console.log('„ Trying to extract userId from JWT token...');
//       try {
//         const token = localStorage.getItem('authToken');
//         if (token) {
//           const decoded = jwtDecode(token);
//           userId = decoded.userId || decoded.id || decoded.user?.id;
//           if (userId) {
//             console.log('✅ Found userId in JWT:', userId);
//             foundKey = 'JWT';
//           }
//         }
//       } catch (error) {
//         console.error('❌ Failed to extract userId from JWT:', error);
//       }
//     }

//     if (!userId) {
//       console.warn('⚠️ No user ID found in localStorage or JWT');
//       console.log('📋 All localStorage keys:', Object.keys(localStorage));
//     } else {
//       console.log('🎯 Using userId from:', foundKey);
//     }

//     console.groupEnd();
//     return userId;
//   }, []);

//   const fetchCurrentUser = async () => {
//     console.group('[DEBUG] fetchCurrentUser() - Starting user profile fetch');

//     try {
//       const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();

//       if (!authToken) {
//         throw new Error('No authentication token found');
//       }

//       const decodedToken = jwtDecode(authToken);
//       console.log('📊 Decoded token structure:', JSON.stringify(decodedToken, null, 2));

//       const userId = getCurrentUserId();
//       const companyId = await getCompanyId();

//       console.log('Current User ID:', userId);
//       console.log('Company ID:', companyId);

//       let userData = null;

//       if (decodedToken.role === 'company') {
//         console.log('Fetching company profile data...');
//         try {
//           const response = await fetch(`${API_BASE_URL}/companies/${decodedToken.id}`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//             console.log('✅ Company profile data fetched successfully');
//           }
//         } catch (error) {
//           console.warn('⚠️ Company profile fetch failed:', error);
//         }
//       } else if (userId && decodedToken.role !== 'company') {
//         console.log('Fetching employee profile data...');
//         try {
//           const response = await fetch(`${API_BASE_URL}/employees/${userId}`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//             console.log('✅ Employee profile data fetched successfully');
//           }
//         } catch (error) {
//           console.warn('⚠️ Employee profile fetch failed:', error);
//         }
//       }

//       if (!userData) {
//         console.log('„ Trying fallback profile endpoint...');
//         try {
//           const response = await fetch(`${API_BASE_URL}/auth/profile`, {
//             method: 'GET',
//             headers: {
//               'Authorization': `Bearer ${authToken}`,
//               'Content-Type': 'application/json',
//             },
//           });

//           if (response.ok) {
//             userData = await response.json();
//             console.log('✅ Fallback profile data fetched successfully');
//           }
//         } catch (error) {
//           console.warn('⚠️ Fallback profile fetch failed:', error);
//         }
//       }

//       if (userData) {
//         const enhancedUserData = {
//           ...userData,
//           id: decodedToken.id,
//           userId: userId || decodedToken.id,
//           role: decodedToken.role,
//           companyId: companyId || decodedToken.companyId,
//           accessPermissions: decodedToken.accessPermissions || [],
//           tokenData: {
//             iat: decodedToken.iat,
//             exp: decodedToken.exp,
//             isExpired: Date.now() >= decodedToken.exp * 1000
//           }
//         };

//         setCurrentUser(enhancedUserData);
//         console.log('✅ User data set successfully:', enhancedUserData);
//       } else {
//         throw new Error('Failed to fetch user data from all endpoints');
//       }

//     } catch (error) {
//       console.error('❌ Error in fetchCurrentUser:', error);

//       try {
//         const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//         const decodedToken = authToken ? jwtDecode(authToken) : null;
//         const userId = getCurrentUserId();
//         const companyId = await getCompanyId();

//         const fallbackUser = {
//           id: decodedToken?.id || userId || 'unknown',
//           userId: userId || decodedToken?.id || 'unknown',
//           name: decodedToken?.role === 'company' ? 'Company Admin' : 'Super Admin',
//           // email: 'admin@company.com',
//           email:'oneclickadmin@gmail.com',
//           role: decodedToken?.role || 'Administrator',
//           companyId: companyId || decodedToken?.companyId || null,
//           accessPermissions: decodedToken?.accessPermissions || [],
//           avatar: null,
//           initials: decodedToken?.role === 'company' ? 'CA' : 'AU',
//           tokenData: decodedToken ? {
//             iat: decodedToken.iat,
//             exp: decodedToken.exp,
//             isExpired: Date.now() >= decodedToken.exp * 1000
//           } : null
//         };

//         setCurrentUser(fallbackUser);
//         console.log('⚠️ Using fallback user data:', fallbackUser);
//       } catch (fallbackError) {
//         console.error('❌ Fallback user creation failed:', fallbackError);
//         setCurrentUser({
//           id: 'unknown',
//           name: 'User',
//           email: 'user@company.com',
//           role: 'User',
//           avatar: null,
//           initials: 'U'
//         });
//       }
//     } finally {
//       console.groupEnd();
//     }
//   };

//   const fetchNotifications = async () => {
//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//       const response = await fetch(`${API_BASE_URL}/notifications`, {
//         method: 'GET',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       if (response.ok) {
//         const notificationData = await response.json();
//         setNotifications(notificationData);
//       } else {
//         setNotifications([]);
//       }
//     } catch (error) {
//       console.error('Error fetching notifications:', error);
//       setNotifications([]);
//     }
//   };

//   const fetchDashboardStats = async () => {
//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();

//       const [employeesRes, tasksRes, projectsRes, ticketsRes] = await Promise.all([
//         fetch(`${API_BASE_URL}/employees/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/tasks/stats`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/projects/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         }),
//         fetch(`${API_BASE_URL}/tickets/count`, {
//           headers: { 'Authorization': `Bearer ${token}` }
//         })
//       ]);

//       const employeeData = employeesRes.ok ? await employeesRes.json() : { count: 0, change: 0 };
//       const taskData = tasksRes.ok ? await tasksRes.json() : { completed: 0, change: 0 };
//       const projectData = projectsRes.ok ? await projectsRes.json() : { count: 0, change: 0 };
//       const ticketData = ticketsRes.ok ? await ticketsRes.json() : { count: 0, change: 0 };

//       setDashboardStats([
//         {
//           title: "Congratulations! 🎉",
//           subtitle: "Best performance this month",
//           value: "$42.8k",
//           percentage: "78% of target 🚀",
//           bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
//           textColor: "text-white",
//           showButton: true
//         },
//         {
//           title: "Total Employees",
//           value: employeeData.count?.toString() || "0",
//           period: "Active Employees",
//           change: employeeData.change ? `${employeeData.change > 0 ? '+' : ''}${employeeData.change}%` : "+0%",
//           changeType: employeeData.change >= 0 ? "positive" : "negative",
//           icon: <FiUsers className="text-[#7367F0]" />
//         },
//         {
//           title: "Tasks Completed",
//           value: taskData.completed?.toString() || "0",
//           period: "This Month",
//           change: taskData.change ? `${taskData.change > 0 ? '+' : ''}${taskData.change}%` : "+0%",
//           changeType: taskData.change >= 0 ? "positive" : "negative",
//           icon: <FiCheckSquare className="text-[#28C76F]" />
//         },
//         {
//           title: "Total Projects",
//           value: projectData.count?.toString() || "0",
//           change: projectData.change ? `${projectData.change > 0 ? '+' : ''}${projectData.change}%` : "+0%",
//           changeType: projectData.change >= 0 ? "positive" : "negative",
//           icon: <FiFolder className="text-[#FF4560]" />
//         },
//         {
//           title: "Support Tickets",
//           value: ticketData.count?.toString() || "0",
//           change: ticketData.change ? `${ticketData.change > 0 ? '+' : ''}${ticketData.change}%` : "+0%",
//           changeType: ticketData.change >= 0 ? "positive" : "negative",
//           icon: <FiActivity className="text-[#00E396]" />
//         }
//       ]);
//     } catch (error) {
//       console.error('Error fetching dashboard stats:', error);
//       setDashboardStats([
//         {
//           title: "Congratulations! 🎉",
//           subtitle: "Best performance this month",
//           value: "$42.8k",
//           percentage: "78% of target 🚀",
//           bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
//           textColor: "text-white",
//           showButton: true
//         },
//         {
//           title: "Total Employees",
//           value: "0",
//           period: "Active Employees",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiUsers className="text-[#7367F0]" />
//         },
//         {
//           title: "Tasks Completed",
//           value: "0",
//           period: "This Month",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiCheckSquare className="text-[#28C76F]" />
//         },
//         {
//           title: "Total Projects",
//           value: "0",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiFolder className="text-[#FF4560]" />
//         },
//         {
//           title: "Support Tickets",
//           value: "0",
//           change: "+0%",
//           changeType: "positive",
//           icon: <FiActivity className="text-[#00E396]" />
//         }
//       ]);
//     }
//   };

//   const markNotificationAsRead = async (notificationId) => {
//     try {
//       const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//       await fetch(`${API_BASE_URL}/notifications/${notificationId}/read`, {
//         method: 'PATCH',
//         headers: {
//           'Authorization': `Bearer ${token}`,
//           'Content-Type': 'application/json',
//         },
//       });

//       setNotifications(prev => 
//         prev.map(notification => 
//           notification.id === notificationId 
//             ? { ...notification, unread: false }
//             : notification
//         )
//       );
//     } catch (error) {
//       console.error('Error marking notification as read:', error);
//     }
//   };

//   const handleLogout = useCallback(() => {
//     console.log('„ Initiating logout (no API required)...');

//     setLogoutMessage('Logging out...');

//     localStorage.removeItem('authToken');
//     localStorage.removeItem('userId');
//     localStorage.removeItem('companyId');
//     localStorage.removeItem('user_id');
//     localStorage.removeItem('employeeId');
//     localStorage.removeItem('employee_id');
//     sessionStorage.clear();

//     console.log(' Storage cleared successfully');

//     setCurrentUser(null);

//     setTimeout(() => {
//       setLogoutMessage('');
//       if (navigate) {
//         navigate('/');
//       } else {
//         window.location.href = '/';
//       }
//       console.log('🚀 Redirected to login page');
//     }, 500);
//   }, [navigate]);

//   const validateToken = useCallback(() => {
//     try {
//       const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
//       if (!authToken) {
//         console.warn('⚠️ No auth token found, redirecting to login...');
//         handleLogout();
//         return false;
//       }

//       const decodedToken = jwtDecode(authToken);
//       const isExpired = Date.now() >= decodedToken.exp * 1000;

//       if (isExpired) {
//         console.warn('⚠️ Token has expired, redirecting to login...');
//         handleLogout();
//         return false;
//       }

//       return true;
//     } catch (error) {
//       console.error('❌ Token validation failed:', error);
//       handleLogout();
//       return false;
//     }
//   }, [handleLogout]);


//   React.useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (isProfileDropdownOpen || isNotificationDropdownOpen) {
//         setIsProfileDropdownOpen(false);
//         setIsNotificationDropdownOpen(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, [isProfileDropdownOpen, isNotificationDropdownOpen]);




//   useEffect(() => {
//     const initializeData = async () => {
//       setLoading(true);

//       if (!validateToken()) {
//         setLoading(false);
//         return;
//       }

//       try {
//         await Promise.all([
//           fetchCurrentUser(),
//           fetchNotifications(),
//           fetchDashboardStats()
//         ]);
//       } catch (error) {
//         setError('Failed to load dashboard data');
//         console.error('Error initializing dashboard:', error);
//       } finally {
//         setLoading(false);
//       }
//     };

//     initializeData();

//     const tokenCheckInterval = setInterval(() => {
//       validateToken();
//     }, 60000);

//     const dataRefreshInterval = setInterval(() => {
//       fetchNotifications();
//       fetchDashboardStats();
//     }, 30000);

//     return () => {
//       clearInterval(tokenCheckInterval);
//       clearInterval(dataRefreshInterval);
//     };
//   }, [validateToken]);

//   const getUserInitials = (name) => {
//     if (!name) return 'U';
//     return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
//   };

//   const toggleSidebar = () => {
//     setIsSidebarOpen(!isSidebarOpen);
//   };

//   const toggleMenu = (menuTitle) => {
//     setExpandedMenus(prev => ({
//       ...prev,
//       [menuTitle]: !prev[menuTitle]
//     }));
//   };

//   // const handleNavigation = (path, title) => {
//   //   setCurrentPath(path);
//   //   setCurrentPage(title);
//   // };

// const handleNavigation = (path, title) => {
//   if (path === 'back') {
//     // Special case: go back to previous path
//     setCurrentPath(previousPath);
//     setCurrentPage(title || 'Previous Page');
//   } else {
//     // Normal navigation: update previous path before changing
//     setPreviousPath(currentPath);
//     setCurrentPath(path);
//     setCurrentPage(title);
//   }
// };

// // NEW: Helper to check if user has a specific permission
// const hasPermission = useCallback((permission) => {
//   if (currentUser?.role === 'company' || currentUser?.role === 'superadmin') {
//     return true;  // Grant full access for company or superadmin roles
//   }
//   return currentUser?.accessPermissions?.includes(permission) || false;
// }, [currentUser]);



//   const menuCategories = useMemo(() => {
//     console.log('Current User Permissions:', currentUser?.accessPermissions);

//   const employeePermissions = ['list_teammember', 'create_teammember', 'update_teammember', 'delete_teammember'];
//   const hasAnyEmployeePermission = employeePermissions.some(perm => hasPermission(perm));

//   // Only include "Employee Management" if user is company/superadmin or has any employee permission
//   const employeeManagementCategory = (currentUser?.role === 'company' || currentUser?.role === 'superadmin' || hasAnyEmployeePermission) ? [
//     {
//       title: "Employee Management",
//       icon: <FiUsers className="text-xl" />,
//       submenus: [
//         { path: "/add-employee", title: "Add Employee", icon: <FiPlus /> },
//          ...(hasPermission('employee_report') ? [{ path: "/employee-report", title: "Employee Report", icon: <FiUsers /> }] : []),
//       ]
//     }
//   ] : [];

//   return [
//     {
//       title: "Dashboard",
//       icon: <FiHome className="text-xl" />,
//       path: "/comprehensivedashboard",
//       submenus: []
//     },
//     ...employeeManagementCategory,  // Conditionally added here
//     {
//       title: "Attendance",
//       icon: <FiCalendar className="text-xl" />,
//       submenus: [
//          ...(hasPermission('daily_attendance') ? [{ path: "/daily-attendance", title: "Daily Attendance", icon: <FiClock /> }] : []),


//         ...(
//             (['company', 'superadmin'].includes(currentUser?.role) ||
//               hasPermission('settings_shift') ||
//               hasPermission('attendance_report'))
//               ? [
//                   ...(hasPermission('settings_shift')
//                     ? [{ path: "/shift-management", title: "Shift Management", icon: <FiCheckSquare /> }]
//                     : []),
//                   ...(hasPermission('attendance_report')
//                     ? [{ path: "/attendance-reports", title: "Attendance Reports", icon: <FiBarChart2 /> }]
//                     : []),
//                 ]
//               : []
//           )

//       ]
//     },
//     {
//       title: "Leaves",
//       icon: <FiBriefcase className="text-xl" />,
//       submenus: [
//         ...(hasPermission('leave_request') ? [{ path: "/leave-request", title: "Leave Request", icon: <FiPlus /> }] : []),
//         ...(hasPermission('leave_approval') ? [{ path: "/leave-approval", title: "Leave Approval", icon: <FiCheckSquare /> }] : []),
//         ...(hasPermission('leave_type') ? [{ path: "/leave-type", title: "Leave Type", icon: <FiFileText /> }] : [])
//       ].filter(Boolean)
//     },
//     {
//       title: "Payroll",
//       icon: <FaRupeeSign className="text-xl" />,
//       submenus: [
//          ...(hasPermission('salary_generation') ? [{ path: "/generate-salary", title: "Generate Salary", icon: <FaRupeeSign /> }] : []),
//       ]
//     },
//     {
//       title: "Support",
//       icon: <FiSettings className="text-xl" />,
//       submenus: [
//         ...(hasPermission('customer_support') ? [{ path: "/customer-support", title: "Customer Support", icon: <FiUsers /> }] : []),
//         ...(hasPermission('com_tickets') ? [{ path: "/com-tickets", title: "Company Tickets", icon: <FiUser /> }] : []),
//         ...(hasPermission('employee_performance') ? [{ path: "/employee-performance", title: "Employee Performance", icon: <FiUser /> }] : []),
//       ]
//     },
//     {
//       title: "Task Management",
//       icon: <FiTarget className="text-xl" />,
//       submenus: [
//         { path: "/tasks", title: "Tasks", icon: <FiCheckSquare /> },
//           ...(hasPermission('task_performance') ? [{ path: "/TaskPerformance", title: "Task Performance", icon: <FiCheckSquare /> }] : []),

//       ]
//     },
//     {
//       title: "Lead Management",
//       icon: <FiTarget className="text-xl" />,
//       submenus: [
//          ...(hasPermission('lead_management') ? [{ path: "/lead-mng", title: "Lead Management", icon: <FiTarget /> }] : []),

//       ]
//     },   
//       {
//         title: "Project Management",
//         icon: <FiBriefcase className="text-xl" />,
//         submenus: [
//           ...(hasPermission('project_dashboard') ? [{ path: "/dashboard-projectmgnt", title: "Projects Dashboard", icon: <FiBarChart2 /> }] : []),
//           ...(hasPermission('projects') ? [{ path: "/projects", title: "Projects", icon: <FiFolder /> }] : []),  // Ensure this is included
//           ...(hasPermission('project_employee_lists') ? [{ path: "/employees", title: "Employee Lists", icon: <FiUsers /> }] : []),
//           ...(hasPermission('project_tracker') ? [{ path: "/kanban", title: "Project Tracker", icon: <FiTarget /> }] : []),
//           ...(hasPermission('project_tasks') ? [{ path: "/project-tasks", title: "Project-Tasks", icon: <FiClock /> }] : []),
//           ...(hasPermission('project_reports') ? [{ path: "/reports", title: "Reports", icon: <FiFileText /> }] : []),
//         ].filter(Boolean)  // Keep filtering empty submenus
//       },
//     {
//       title: "Settings",
//       icon: <FiSettings className="text-xl" />,
//       submenus: (() => {
//         const baseSubmenus = [
//           { path: "/departments", title: "Departments", icon: <FiUsers /> },
//           { path: "/designations", title: "Designations", icon: <FiUser /> },
//           // { path: "/role-permissions", title: "Role Permissions", icon: <FiSettings /> }
//         ];
//         const adminOnlySubmenus = [
//           { path: "/companies", title: "Companies", icon: <FiBriefcase /> },
//           { path: "/franchises", title: "Franchises", icon: <FiSettings /> },
//           { path: "/branch", title: "Branch", icon: <FiSettings /> },
//           { path: "/subscription", title: "Subscription", icon: <FiSettings /> }
//         ];
//         const isAdmin = currentUser && ['superadmin', 'franchise'].includes(currentUser.role);
//         return isAdmin ? [...baseSubmenus, ...adminOnlySubmenus] : baseSubmenus;
//       })()
//     }
//   ].filter(category => category.submenus.length > 0 || category.path);  // Existing filter
// }, [currentUser, hasPermission]);

//   const renderDashboardContent = () => (
//     <ComprehensiveDashboard/>
//   );

//   const renderPageContent = () => {
//     switch (currentPath) {
//       case '/comprehensivedashboard':
//         return <ComprehensiveDashboard/>;
//       case '/add-employee':
//         return <AddEmployee />;
//       case '/employee-report':
//         return <EmployeeReport />;
//       case '/daily-attendance':
//         return <DailyAttendance />;
//       case '/shift-management':
//         return <ShiftManagement />;
//       case '/attendance-reports':
//         return <AttendanceReports />;
//       case '/leave-request':
//         return <LeaveRequest />;
//       case '/leave-approval':
//         return <LeaveApproval />;
//       case '/leave-type':
//         return <LeaveType />;
//       case '/salary-setup':
//         return <SalaryAdvance />;
//       case '/generate-salary':
//         return <GenerateSalary />;
//       case '/policies':
//         return <Policies />;
//       case '/employee-docs':
//         return <EmployeeDocs />;
//       case '/customer-support':
//         return <CustomerSupport />;
//       case '/com-tickets':
//         return <AssignTickets />;
//       case '/sup-tickets':
//         return <SupportTickets />;
//       case '/employee-performance':
//         return <EmployeePerformance />;
//       case '/tasks':
//         return <Tasks />;
//       case '/TaskPerformance':
//         return <TaskPerformance />;
//       case '/lead-mng':
//         return <DashboardLead />;
//       case '/dashboard-projectmgnt':
//         return <ProjectDashboard projects={localProjects} employees={employees} milestones={milestones} onNavigate={handleNavigation} />;
//       // case '/projects':
//       //   return <ProjectList projects={localProjects} setProjects={setLocalProjects}  onNavigate={handleNavigation} />;

//        case '/projects':
//       // Handle /projects with optional query params for employee filtering
//       const urlParams = new URLSearchParams(currentPath.split('?')[1] || '');
//       const employeeId = urlParams.get('employeeId');
//       const employeeName = urlParams.get('employeeName');
//       const employeeFilter = employeeId && employeeName ? { id: employeeId, name: employeeName } : null;

//       return (
//         <ProjectList 
//           projects={localProjects} 
//           setProjects={setLocalProjects} 
//           onNavigate={handleNavigation} 
//           employeeFilter={employeeFilter}  // Pass filter if present
//         />
//       );
//       case '/add-project':
//         return <AddProject onNavigate={handleNavigation} />;

//       case '/projects/add':
//         return <AddProject onNavigate={handleNavigation} />;

//       case '/employees':
//         return <EmployeeLists onNavigate={handleNavigation}/>;
//       case '/kanban':
//         return <ProjectTracker projects={localProjects} setProjects={setLocalProjects} milestones={milestones} setMilestones={setMilestones} />;

//       case '/project-tasks':
//         return <ProjectTasksManagement projects={localProjects} setProjects={setLocalProjects} milestones={milestones} setMilestones={setMilestones} />;


//       case '/reports':
//         return <Reports projects={localProjects} employees={employees} milestones={milestones} />;
//       case '/departments':
//         return <Departments />;
//       case '/designations':
//         return <Designations />;
//       // case '/designation':
//       //   return <Designation />;
//       // case '/role-permissions':
//       //   return <RolePermissions />;
//       case '/companies':
//         return <Companies />;
//       case '/franchise':
//         return <Franchise />;
//       case '/branch':
//         return <Branch />;
//       case '/subscription':
//         return <Subscription />;
//       default:
//       // Handle /projects/:id path for individual project view
//        const projectPathMatch = currentPath.match(/^\/projects\/(.+)$/);
//       if (projectPathMatch) {
//         const projectId = projectPathMatch[1];
//         return (
//           <ProjectView
//             projects={localProjects}
//             employees={employees}
//             milestones={milestones}
//             setMilestones={setMilestones}
//             onNavigate={handleNavigation}  // Ensure this is included
//             projectId={projectId}
//           />
//         );
//       }
//       return renderDashboardContent();
//     };
//   };



//   return (
//     <div className="flex h-screen bg-[#F8F9FA]">
//       <div className={`bg-[#282a42] shadow-2xl transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-20'} border-r border-[#30334e] z-40`}>
//         <div className="flex items-center justify-between p-4 border-b border-[#30334e]">
//           {isSidebarOpen && (
//             <div className="flex items-center space-x-2">
//               <div className="w-8 h-8 bg-[#7367F0] rounded-lg flex items-center justify-center shadow-lg">
//                 <span className="text-white font-bold text-sm">H</span>
//               </div>
//               <h1 className="text-xl font-bold text-[#d7d8ee]">CRM</h1>
//             </div>
//           )}
//           <button 
//             onClick={toggleSidebar} 
//             className="p-2 rounded-lg hover:bg-[#30334e] transition-all duration-200 text-[#d7d8ee] hover:text-white"
//           >
//             {isSidebarOpen ? <FiX /> : <FiMenu />}
//           </button>
//         </div>

//         <nav className="mt-4 px-4 pb-4 overflow-y-auto max-h-[calc(100vh-180px)] custom-scrollbar">
//           <div className="space-y-1">
//             {menuCategories.map((category, index) => (
//               <div key={index} className="mb-1">
//                 {category.submenus.length > 0 ? (
//                   <>
//                     <button
//                       onClick={() => toggleMenu(category.title)}
//                       className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${
//                         expandedMenus[category.title] 
//                           ? 'bg-[#7367F0] text-white shadow-lg' 
//                           : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                       }`}
//                     >
//                       <span className={`mr-3 transition-colors duration-200 ${
//                         expandedMenus[category.title] ? 'text-white' : 'text-[#b8b9d4]'
//                       }`}>
//                         {category.icon}
//                       </span>

//                       {isSidebarOpen && (
//                         <>
//                           <span className="flex-1 text-left font-medium text-sm">
//                             {category.title}
//                           </span>
//                           <span className={`text-sm transition-transform duration-200 ${
//                             expandedMenus[category.title] ? 'rotate-180' : ''
//                           }`}>
//                             <FiChevronDown />
//                           </span>
//                         </>
//                       )}

//                       {expandedMenus[category.title] && (
//                         <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
//                       )}
//                     </button>

//                     {isSidebarOpen && expandedMenus[category.title] && (
//                       <div className="pl-4 mt-2 space-y-1">
//                         {category.submenus.map((submenu, subIndex) => (
//                           <button
//                             key={subIndex}
//                             onClick={() => handleNavigation(submenu.path, submenu.title)}
//                             className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl text-sm group ${
//                               currentPath === submenu.path 
//                                 ? 'bg-[#3b3d57] text-white shadow-md border-l-2 border-[#7367F0]' 
//                                 : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                             }`}
//                           >
//                             <span className={`mr-3 text-sm transition-colors duration-200 ${
//                               currentPath === submenu.path ? 'text-[#7367F0]' : 'text-[#b8b9d4]'
//                             }`}>
//                               {submenu.icon}
//                             </span>
//                             <span className="font-medium">{submenu.title}</span>

//                             {currentPath === submenu.path && (
//                               <div className="ml-auto w-2 h-2 bg-[#7367F0] rounded-full"></div>
//                             )}
//                           </button>
//                         ))}
//                       </div>
//                     )}
//                   </>
//                 ) : (
//                   <button
//                     onClick={() => handleNavigation(category.path, category.title)}
//                     className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${
//                       currentPath === category.path 
//                         ? 'bg-[#7367F0] text-white shadow-lg' 
//                         : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
//                     }`}
//                   >
//                     <span className={`mr-3 transition-colors duration-200 ${
//                       currentPath === category.path ? 'text-white' : 'text-[#b8b9d4]'
//                     }`}>
//                       {category.icon}
//                     </span>

//                     {isSidebarOpen && (
//                       <span className="font-medium text-sm">{category.title}</span>
//                     )}

//                     {currentPath === category.path && (
//                       <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
//                     )}
//                   </button>
//                 )}
//               </div>
//             ))}
//           </div>
//         </nav>
//       </div>

//       <div className="flex-1 flex flex-col overflow-hidden">
//         {/* TopBar Component */}
//         <TopBar 
//           currentPage={currentPage}
//           currentUser={currentUser}
//           isProfileDropdownOpen={isProfileDropdownOpen}
//           setIsProfileDropdownOpen={setIsProfileDropdownOpen}
//           onLogout={handleLogout}
//           getUserInitials={getUserInitials}
//           onNavigate={handleNavigation}
//         />

//         <div className="flex-1 overflow-auto p-6">
//           {renderPageContent()}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default FranchiseDashboard;









































import React, { useState, useEffect, useCallback, useMemo } from "react";
import { FaRupeeSign } from "react-icons/fa";
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import {
  FiUsers, FiCalendar, FiBriefcase, FiDollarSign,
  FiTrendingUp, FiFileText, FiBarChart2, FiSettings,
  FiPlus, FiList, FiUser, FiClock, FiCheckSquare,
  FiDownload, FiTarget, FiFile, FiFolder, FiAward,
  FiHome, FiMenu, FiX, FiChevronDown, FiChevronRight,
  FiBell, FiSearch, FiMoreVertical, FiActivity,
  FiShoppingCart, FiLock, FiTrendingDown, FiLogOut,
  FiMail, FiPhone, FiMapPin, FiSun, FiMoon, FiMaximize2
} from "react-icons/fi";
import axios from 'axios';  // For API calls (or use fetch)

// Franchise Components - Same directory
import AddEmployee from './AddEmployee';
import DailyAttendance from './DailyAttendance';
import ShiftManagement from './ShiftManagement';
import AttendanceReports from './AttendanceReports';
import SalaryAdvance from './SalaryAdvance';
import GenerateSalary from './GenerateSalary';
import Policies from './Policies';
import EmployeeDocs from './EmployeeDocs';
import Departments from './Departments';
import Designations from './Designations';
// import RolePermissions from './RolePermissions';
import Companies from './Companies';
import EmployeeReport from './EmployeeReport';
// import Designation from './Designation';
import LeaveRequest from './LeaveRequest';
import LeaveApproval from './LeaveApproval';
import Franchise from './Franchises';
import Branch from './Branch';
import LeaveType from './LeaveType';
import Subscription from './Subscription';
// Support Components - Corrected paths
import CustomerSupport from '../../Support/Cutomer/CustomerSupport';
import AssignTickets from '../../Support/Company/AssignTickets';
import SupportTickets from '../../Support/employee/SupportTickets';
import EmployeePerformance from '../../Support/Company/EmployeePerformance';

// Task Management Components - Corrected paths
import Tasks from '../../pages/Tasks';
import TaskPerformance from '../../pages/TaskPerformance';

// Project Management Components - Corrected paths
import ProjectList from '../../ProjectManagemnet/components/ProjectList';
import ProjectTracker from '../../ProjectManagemnet/components/ProjectTracker';
import EmployeeLists from '../../ProjectManagemnet/components/EmployeeLists';
import MilestoneList from '../../ProjectManagemnet/components/MilestoneList';
import ProjectDashboard from '../../ProjectManagemnet/pages/Dashboard';
import Reports from '../../ProjectManagemnet/components/Reports';
import AddProject from '../../ProjectManagemnet/components/AddProject';
import ProjectTasksManagement from '../../ProjectManagemnet/components/FollowUpTasks';

// Lead Management Components - Corrected paths
import DashboardLead from '../../LeadMng/components/DashboardLead';
import ProjectView from '../../ProjectManagemnet/components/ProjectView';
// Import the new TopBar component
import TopBar from '../../Components/TopBar'
import ComprehensiveDashboard from "../../Components/DashAll/ComprehensiveDashboard";

function FranchiseDashboard({ projects: propProjects, employees, milestones, setProjects: propSetProjects, setMilestones }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [currentPage, setCurrentPage] = useState('Dashboard');
  const [currentPath, setCurrentPath] = useState('/dashboard');
  const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
  const [isNotificationDropdownOpen, setIsNotificationDropdownOpen] = useState(false);
  const [previousPath, setPreviousPath] = useState('/projects');  // Default to projects list for back navigation

  const navigate = useNavigate();
  const [logoutMessage, setLogoutMessage] = useState('');

  // Real data state
  const [currentUser, setCurrentUser] = useState(null);
  const [notifications, setNotifications] = useState([]);
  const [dashboardStats, setDashboardStats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // API base URL
  const API_BASE_URL = 'https://greenyellow-nightingale-241896.hostingersite.com/api';
  const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
  const [localProjects, setLocalProjects] = useState(propProjects || []);


  // Function to fetch projects (similar to ProjectList's fetchProjects)
  const fetchProjects = useCallback(async () => {
    try {
      console.log('Dashboard - fetchProjects called');
      const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
      if (!token) {
        console.error('No access token found');
        return;
      }
      const response = await axios.get(`${API_BASE_URL}/projectsmgnt`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.status === 200) {
        const data = response.data;
        console.log('Dashboard - Fetched projects:', data.length, 'projects');
        setLocalProjects(data);
        if (propSetProjects) propSetProjects(data);  // Sync with parent if needed
      } else {
        console.error('Failed to fetch projects:', response.status);
      }
    } catch (error) {
      console.error('Error fetching projects in Dashboard:', error);
    }
  }, [propSetProjects]);

  // Fetch projects on mount
  useEffect(() => {
    console.log('„ FranchiseDashboard mount effect - fetching projects');
    fetchProjects();
  }, [fetchProjects]);

  // Update localProjects if prop changes (e.g., from App.js)
  useEffect(() => {
    if (propProjects && propProjects.length > 0) {
      setLocalProjects(propProjects);
    }
  }, [propProjects]);



  // Utility functions
  const getCompanyId = useCallback(async () => {
    console.group('[DEBUG] getCompanyId() - Starting company ID resolution');

    const token = localStorage.getItem('authToken');
    console.log('📋 Token from localStorage:', token ? `${token.substring(0, 50)}...` : 'null');

    if (token) {
      try {
        console.log(' Attempting to decode JWT token...');
        const decodedToken = jwtDecode(token);
        console.log('📊 Decoded token structure:', JSON.stringify(decodedToken, null, 2));

        if (decodedToken && decodedToken.role === 'company') {
          if (decodedToken.id) {
            console.groupEnd();
            return decodedToken.id;
          }
        } else {
          if (decodedToken && decodedToken.companyId) {
            console.groupEnd();
            return decodedToken.companyId;
          }
        }

        if (decodedToken && (decodedToken.userId || decodedToken.id)) {
          const userId = decodedToken.userId || decodedToken.id;
          console.log('Employee ID from JWT:', userId);
          console.log('„ Attempting to fetch employee profile from MongoDB...');
        } else {
          console.warn('⚠️ No userId or id found in JWT token');
          console.log('Token payload keys available:', Object.keys(decodedToken || {}));
        }
      } catch (error) {
        console.error('❌ JWT decoding failed:', error);
        console.warn('„ Trying alternative methods...');
      }
    } else {
      console.warn('⚠️ No authToken found in localStorage');
      console.log('📋 All localStorage keys:', Object.keys(localStorage));
    }

    const storedCompanyId = localStorage.getItem('companyId');
    if (storedCompanyId) {
      console.log('✅ Found companyId in localStorage:', storedCompanyId);
      console.groupEnd();
      return storedCompanyId;
    } else {
      console.warn('⚠️ No companyId found in localStorage');
    }

    console.error('❌ Unable to resolve company ID from any source');
    console.groupEnd();
    return null;
  }, []);

  const getCurrentUserId = useCallback(() => {
    console.group('[DEBUG] getCurrentUserId()');

    const possibleKeys = ['userId', 'user_id', 'id', 'employeeId', 'employee_id'];
    let userId = null;
    let foundKey = null;

    for (const key of possibleKeys) {
      const value = localStorage.getItem(key);
      if (value) {
        userId = value.replace(/['"]/g, '').trim();
        foundKey = key;
        console.log(`✅ Found userId with key '${key}':`, userId);
        break;
      }
      console.log(`❌ No value for key '${key}'`);
    }

    if (!userId) {
      console.log('„ Trying to extract userId from JWT token...');
      try {
        const token = localStorage.getItem('authToken');
        if (token) {
          const decoded = jwtDecode(token);
          userId = decoded.userId || decoded.id || decoded.user?.id;
          if (userId) {
            console.log('✅ Found userId in JWT:', userId);
            foundKey = 'JWT';
          }
        }
      } catch (error) {
        console.error('❌ Failed to extract userId from JWT:', error);
      }
    }

    if (!userId) {
      console.warn('⚠️ No user ID found in localStorage or JWT');
      console.log('📋 All localStorage keys:', Object.keys(localStorage));
    } else {
      console.log('🎯 Using userId from:', foundKey);
    }

    console.groupEnd();
    return userId;
  }, []);

  const fetchCurrentUser = async () => {
    console.group('[DEBUG] fetchCurrentUser() - Starting user profile fetch');

    try {
      const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();

      if (!authToken) {
        throw new Error('No authentication token found');
      }

      const decodedToken = jwtDecode(authToken);
      console.log('📊 Decoded token structure:', JSON.stringify(decodedToken, null, 2));

      const userId = getCurrentUserId();
      const companyId = await getCompanyId();

      console.log('Current User ID:', userId);
      console.log('Company ID:', companyId);

      let userData = null;

      if (decodedToken.role === 'company') {
        console.log('Fetching company profile data...');
        try {
          const response = await fetch(`${API_BASE_URL}/companies/${decodedToken.id}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json',
            },
          });

          if (response.ok) {
            userData = await response.json();
            console.log('✅ Company profile data fetched successfully');
          }
        } catch (error) {
          console.warn('⚠️ Company profile fetch failed:', error);
        }
      } else if (userId && decodedToken.role !== 'company') {
        console.log('Fetching employee profile data...');
        try {
          const response = await fetch(`${API_BASE_URL}/employees/${userId}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json',
            },
          });

          if (response.ok) {
            userData = await response.json();
            console.log('✅ Employee profile data fetched successfully');
          }
        } catch (error) {
          console.warn('⚠️ Employee profile fetch failed:', error);
        }
      }

      if (!userData) {
        console.log('„ Trying fallback profile endpoint...');
        try {
          const response = await fetch(`${API_BASE_URL}/auth/profile`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${authToken}`,
              'Content-Type': 'application/json',
            },
          });

          if (response.ok) {
            userData = await response.json();
            console.log('✅ Fallback profile data fetched successfully');
          }
        } catch (error) {
          console.warn('⚠️ Fallback profile fetch failed:', error);
        }
      }

      if (userData) {
        const enhancedUserData = {
          ...userData,
          id: decodedToken.id,
          userId: userId || decodedToken.id,
          role: decodedToken.role,
          companyId: companyId || decodedToken.companyId,
          accessPermissions: decodedToken.accessPermissions || [],
          tokenData: {
            iat: decodedToken.iat,
            exp: decodedToken.exp,
            isExpired: Date.now() >= decodedToken.exp * 1000
          }
        };

        setCurrentUser(enhancedUserData);
        console.log('✅ User data set successfully:', enhancedUserData);
      } else {
        throw new Error('Failed to fetch user data from all endpoints');
      }

    } catch (error) {
      console.error('❌ Error in fetchCurrentUser:', error);

      try {
        const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
        const decodedToken = authToken ? jwtDecode(authToken) : null;
        const userId = getCurrentUserId();
        const companyId = await getCompanyId();

        const fallbackUser = {
          id: decodedToken?.id || userId || 'unknown',
          userId: userId || decodedToken?.id || 'unknown',
          name: decodedToken?.role === 'company' ? 'Company Admin' : 'Super Admin',
          // email: 'admin@company.com',
          email: 'oneclickadmin@gmail.com',
          role: decodedToken?.role || 'Administrator',
          companyId: companyId || decodedToken?.companyId || null,
          accessPermissions: decodedToken?.accessPermissions || [],
          avatar: null,
          initials: decodedToken?.role === 'company' ? 'CA' : 'AU',
          tokenData: decodedToken ? {
            iat: decodedToken.iat,
            exp: decodedToken.exp,
            isExpired: Date.now() >= decodedToken.exp * 1000
          } : null
        };

        setCurrentUser(fallbackUser);
        console.log('⚠️ Using fallback user data:', fallbackUser);
      } catch (fallbackError) {
        console.error('❌ Fallback user creation failed:', fallbackError);
        setCurrentUser({
          id: 'unknown',
          name: 'User',
          email: 'user@company.com',
          role: 'User',
          avatar: null,
          initials: 'U'
        });
      }
    } finally {
      console.groupEnd();
    }
  };

  const fetchNotifications = async () => {
    try {
      const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
      const response = await fetch(`${API_BASE_URL}/notifications`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        const notificationData = await response.json();
        setNotifications(notificationData);
      } else {
        setNotifications([]);
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
      setNotifications([]);
    }
  };

  const fetchDashboardStats = async () => {
    try {
      const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();

      const [employeesRes, tasksRes, projectsRes, ticketsRes] = await Promise.all([
        fetch(`${API_BASE_URL}/employees/count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch(`${API_BASE_URL}/tasks/stats`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch(`${API_BASE_URL}/projects/count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        }),
        fetch(`${API_BASE_URL}/tickets/count`, {
          headers: { 'Authorization': `Bearer ${token}` }
        })
      ]);

      const employeeData = employeesRes.ok ? await employeesRes.json() : { count: 0, change: 0 };
      const taskData = tasksRes.ok ? await tasksRes.json() : { completed: 0, change: 0 };
      const projectData = projectsRes.ok ? await projectsRes.json() : { count: 0, change: 0 };
      const ticketData = ticketsRes.ok ? await ticketsRes.json() : { count: 0, change: 0 };

      setDashboardStats([
        {
          title: "Congratulations! 🎉",
          subtitle: "Best performance this month",
          value: "$42.8k",
          percentage: "78% of target 🚀",
          bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
          textColor: "text-white",
          showButton: true
        },
        {
          title: "Total Employees",
          value: employeeData.count?.toString() || "0",
          period: "Active Employees",
          change: employeeData.change ? `${employeeData.change > 0 ? '+' : ''}${employeeData.change}%` : "+0%",
          changeType: employeeData.change >= 0 ? "positive" : "negative",
          icon: <FiUsers className="text-[#7367F0]" />
        },
        {
          title: "Tasks Completed",
          value: taskData.completed?.toString() || "0",
          period: "This Month",
          change: taskData.change ? `${taskData.change > 0 ? '+' : ''}${taskData.change}%` : "+0%",
          changeType: taskData.change >= 0 ? "positive" : "negative",
          icon: <FiCheckSquare className="text-[#28C76F]" />
        },
        {
          title: "Total Projects",
          value: projectData.count?.toString() || "0",
          change: projectData.change ? `${projectData.change > 0 ? '+' : ''}${projectData.change}%` : "+0%",
          changeType: projectData.change >= 0 ? "positive" : "negative",
          icon: <FiFolder className="text-[#FF4560]" />
        },
        {
          title: "Support Tickets",
          value: ticketData.count?.toString() || "0",
          change: ticketData.change ? `${ticketData.change > 0 ? '+' : ''}${ticketData.change}%` : "+0%",
          changeType: ticketData.change >= 0 ? "positive" : "negative",
          icon: <FiActivity className="text-[#00E396]" />
        }
      ]);
    } catch (error) {
      console.error('Error fetching dashboard stats:', error);
      setDashboardStats([
        {
          title: "Congratulations! 🎉",
          subtitle: "Best performance this month",
          value: "$42.8k",
          percentage: "78% of target 🚀",
          bgColor: "bg-gradient-to-r from-[#7367F0] to-[#5A67D8]",
          textColor: "text-white",
          showButton: true
        },
        {
          title: "Total Employees",
          value: "0",
          period: "Active Employees",
          change: "+0%",
          changeType: "positive",
          icon: <FiUsers className="text-[#7367F0]" />
        },
        {
          title: "Tasks Completed",
          value: "0",
          period: "This Month",
          change: "+0%",
          changeType: "positive",
          icon: <FiCheckSquare className="text-[#28C76F]" />
        },
        {
          title: "Total Projects",
          value: "0",
          change: "+0%",
          changeType: "positive",
          icon: <FiFolder className="text-[#FF4560]" />
        },
        {
          title: "Support Tickets",
          value: "0",
          change: "+0%",
          changeType: "positive",
          icon: <FiActivity className="text-[#00E396]" />
        }
      ]);
    }
  };

  const markNotificationAsRead = async (notificationId) => {
    try {
      const token = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
      await fetch(`${API_BASE_URL}/notifications/${notificationId}/read`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });

      setNotifications(prev =>
        prev.map(notification =>
          notification.id === notificationId
            ? { ...notification, unread: false }
            : notification
        )
      );
    } catch (error) {
      console.error('Error marking notification as read:', error);
    }
  };

  const handleLogout = useCallback(() => {
    console.log('„ Initiating logout (no API required)...');

    setLogoutMessage('Logging out...');

    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('companyId');
    localStorage.removeItem('user_id');
    localStorage.removeItem('employeeId');
    localStorage.removeItem('employee_id');
    sessionStorage.clear();

    console.log(' Storage cleared successfully');

    setCurrentUser(null);

    setTimeout(() => {
      setLogoutMessage('');
      if (navigate) {
        navigate('/');
      } else {
        window.location.href = '/';
      }
      console.log('🚀 Redirected to login page');
    }, 500);
  }, [navigate]);

  const validateToken = useCallback(() => {
    try {
      const authToken = localStorage.getItem('authToken')?.replace(/['"]/g, '').trim();
      if (!authToken) {
        console.warn('⚠️ No auth token found, redirecting to login...');
        handleLogout();
        return false;
      }

      const decodedToken = jwtDecode(authToken);
      const isExpired = Date.now() >= decodedToken.exp * 1000;

      if (isExpired) {
        console.warn('⚠️ Token has expired, redirecting to login...');
        handleLogout();
        return false;
      }

      return true;
    } catch (error) {
      console.error('❌ Token validation failed:', error);
      handleLogout();
      return false;
    }
  }, [handleLogout]);


  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (isProfileDropdownOpen || isNotificationDropdownOpen) {
        setIsProfileDropdownOpen(false);
        setIsNotificationDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileDropdownOpen, isNotificationDropdownOpen]);




  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);

      if (!validateToken()) {
        setLoading(false);
        return;
      }

      try {
        await Promise.all([
          fetchCurrentUser(),
          fetchNotifications(),
          fetchDashboardStats()
        ]);
      } catch (error) {
        setError('Failed to load dashboard data');
        console.error('Error initializing dashboard:', error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();

    const tokenCheckInterval = setInterval(() => {
      validateToken();
    }, 60000);

    const dataRefreshInterval = setInterval(() => {
      fetchNotifications();
      fetchDashboardStats();
    }, 30000);

    return () => {
      clearInterval(tokenCheckInterval);
      clearInterval(dataRefreshInterval);
    };
  }, [validateToken]);

  const getUserInitials = (name) => {
    if (!name) return 'U';
    return name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2);
  };

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleMenu = (menuTitle) => {
    setExpandedMenus(prev => ({
      ...prev,
      [menuTitle]: !prev[menuTitle]
    }));
  };

  // const handleNavigation = (path, title) => {
  //   setCurrentPath(path);
  //   setCurrentPage(title);
  // };

  const handleNavigation = (path, title) => {
    if (path === 'back') {
      // Special case: go back to previous path
      // If coming from a project detail view and no previous path, default to /projects
      const targetPath = previousPath || '/projects';
      console.log('™ Back button clicked:', {
        previousPath,
        targetPath,
        currentPath,
        currentPage
      });
      setCurrentPath(targetPath);
      setCurrentPage(title || 'Previous Page');
    } else {
      // Normal navigation: update previous path before changing
      console.log('Navigation - storing previous path:', {
        currentPath,
        newPath: path,
        title
      });
      setPreviousPath(currentPath);
      setCurrentPath(path);
      setCurrentPage(title);

      // If navigating to a project detail view and projects aren't loaded, fetch them
      if (path.startsWith('/projects/') && (!localProjects || localProjects.length === 0)) {
        console.log('„ Fetching projects before showing detail view');
        fetchProjects();
      }
    }
  };

  // NEW: Helper to check if user has a specific permission
  const hasPermission = useCallback((permission) => {
    if (currentUser?.role === 'company' || currentUser?.role === 'superadmin') {
      return true;  // Grant full access for company or superadmin roles
    }
    return currentUser?.accessPermissions?.includes(permission) || false;
  }, [currentUser]);



  const menuCategories = useMemo(() => {
    console.log('Current User Permissions:', currentUser?.accessPermissions);

    const employeePermissions = ['list_teammember', 'create_teammember', 'update_teammember', 'delete_teammember'];
    const hasAnyEmployeePermission = employeePermissions.some(perm => hasPermission(perm));

    // Only include "Employee Management" if user is company/superadmin or has any employee permission
    const employeeManagementCategory = (currentUser?.role === 'company' || currentUser?.role === 'superadmin' || hasAnyEmployeePermission) ? [
      {
        title: "Employee Management",
        icon: <FiUsers className="text-xl" />,
        submenus: [
          { path: "/add-employee", title: "Add Employee", icon: <FiPlus /> },
          ...(hasPermission('employee_report') ? [{ path: "/employee-report", title: "Employee Report", icon: <FiUsers /> }] : []),
        ]
      }
    ] : [];

    return [
      {
        title: "Dashboard",
        icon: <FiHome className="text-xl" />,
        path: "/comprehensivedashboard",
        submenus: []
      },
      ...employeeManagementCategory,  // Conditionally added here
      {
        title: "Attendance",
        icon: <FiCalendar className="text-xl" />,
        submenus: [
          ...(hasPermission('daily_attendance') ? [{ path: "/daily-attendance", title: "Daily Attendance", icon: <FiClock /> }] : []),


          ...(
            (['company', 'superadmin'].includes(currentUser?.role) ||
              hasPermission('settings_shift') ||
              hasPermission('attendance_report'))
              ? [
                ...(hasPermission('settings_shift')
                  ? [{ path: "/shift-management", title: "Shift Management", icon: <FiCheckSquare /> }]
                  : []),
                ...(hasPermission('attendance_report')
                  ? [{ path: "/attendance-reports", title: "Attendance Reports", icon: <FiBarChart2 /> }]
                  : []),
              ]
              : []
          )

        ]
      },
      {
        title: "Leaves",
        icon: <FiBriefcase className="text-xl" />,
        submenus: [
          ...(hasPermission('leave_request') ? [{ path: "/leave-request", title: "Leave Request", icon: <FiPlus /> }] : []),
          ...(hasPermission('leave_approval') ? [{ path: "/leave-approval", title: "Leave Approval", icon: <FiCheckSquare /> }] : []),
          ...(hasPermission('leave_type') ? [{ path: "/leave-type", title: "Leave Type", icon: <FiFileText /> }] : [])
        ].filter(Boolean)
      },
      {
        title: "Payroll",
        icon: <FaRupeeSign className="text-xl" />,
        submenus: [
          ...(hasPermission('salary_generation') ? [{ path: "/generate-salary", title: "Generate Salary", icon: <FaRupeeSign /> }] : []),
        ]
      },
      {
        title: "Support",
        icon: <FiSettings className="text-xl" />,
        submenus: [
          ...(hasPermission('customer_support') ? [{ path: "/customer-support", title: "Customer Support", icon: <FiUsers /> }] : []),
          ...(hasPermission('com_tickets') ? [{ path: "/com-tickets", title: "Company Tickets", icon: <FiUser /> }] : []),
          ...(hasPermission('employee_performance') ? [{ path: "/employee-performance", title: "Employee Performance", icon: <FiUser /> }] : []),
        ]
      },
      {
        title: "Task Management",
        icon: <FiTarget className="text-xl" />,
        submenus: [
          { path: "/tasks", title: "Tasks", icon: <FiCheckSquare /> },
          ...(hasPermission('task_performance') ? [{ path: "/TaskPerformance", title: "Task Performance", icon: <FiCheckSquare /> }] : []),

        ]
      },
      {
        title: "Lead Management",
        icon: <FiTarget className="text-xl" />,
        submenus: [
          ...(hasPermission('lead_management') ? [{ path: "/lead-mng", title: "Lead Management", icon: <FiTarget /> }] : []),

        ]
      },
      {
        title: "Project Management",
        icon: <FiBriefcase className="text-xl" />,
        submenus: [
          ...(hasPermission('project_dashboard') ? [{ path: "/dashboard-projectmgnt", title: "Projects Dashboard", icon: <FiBarChart2 /> }] : []),
          ...(hasPermission('projects') ? [{ path: "/projects", title: "Projects", icon: <FiFolder /> }] : []),  // Ensure this is included
          ...(hasPermission('project_employee_lists') ? [{ path: "/employees", title: "Employee Lists", icon: <FiUsers /> }] : []),
          ...(hasPermission('project_tracker') ? [{ path: "/kanban", title: "Project Tracker", icon: <FiTarget /> }] : []),
          ...(hasPermission('project_tasks') ? [{ path: "/project-tasks", title: "Project-Tasks", icon: <FiClock /> }] : []),
          ...(hasPermission('project_reports') ? [{ path: "/reports", title: "Reports", icon: <FiFileText /> }] : []),
        ].filter(Boolean)  // Keep filtering empty submenus
      },
      {
        title: "Settings",
        icon: <FiSettings className="text-xl" />,
        submenus: (() => {
          const baseSubmenus = [
            { path: "/departments", title: "Departments", icon: <FiUsers /> },
            { path: "/designations", title: "Designations", icon: <FiUser /> },
            // { path: "/role-permissions", title: "Role Permissions", icon: <FiSettings /> }
          ];
          const adminOnlySubmenus = [
            { path: "/companies", title: "Companies", icon: <FiBriefcase /> },
            { path: "/franchises", title: "Franchises", icon: <FiSettings /> },
            { path: "/branch", title: "Branch", icon: <FiSettings /> },
            { path: "/subscription", title: "Subscription", icon: <FiSettings /> }
          ];
          const isAdmin = currentUser && ['superadmin', 'franchise'].includes(currentUser.role);
          return isAdmin ? [...baseSubmenus, ...adminOnlySubmenus] : baseSubmenus;
        })()
      }
    ].filter(category => category.submenus.length > 0 || category.path);  // Existing filter
  }, [currentUser, hasPermission]);

  const renderDashboardContent = () => (
    <ComprehensiveDashboard />
  );

  const renderPageContent = () => {
    console.log('„ renderPageContent called with currentPath:', currentPath, 'localProjects:', localProjects?.length);
    switch (currentPath) {
      case '/comprehensivedashboard':
        return <ComprehensiveDashboard />;
      case '/add-employee':
        return <AddEmployee />;
      case '/employee-report':
        return <EmployeeReport />;
      case '/daily-attendance':
        return <DailyAttendance />;
      case '/shift-management':
        return <ShiftManagement />;
      case '/attendance-reports':
        return <AttendanceReports />;
      case '/leave-request':
        return <LeaveRequest />;
      case '/leave-approval':
        return <LeaveApproval />;
      case '/leave-type':
        return <LeaveType />;
      case '/salary-setup':
        return <SalaryAdvance />;
      case '/generate-salary':
        return <GenerateSalary />;
      case '/policies':
        return <Policies />;
      case '/employee-docs':
        return <EmployeeDocs />;
      case '/customer-support':
        return <CustomerSupport />;
      case '/com-tickets':
        return <AssignTickets />;
      case '/sup-tickets':
        return <SupportTickets />;
      case '/employee-performance':
        return <EmployeePerformance />;
      case '/tasks':
        return <Tasks />;
      case '/TaskPerformance':
        return <TaskPerformance />;
      case '/lead-mng':
        return <DashboardLead />;
      case '/dashboard-projectmgnt':
        return <ProjectDashboard projects={localProjects} employees={employees} milestones={milestones} onNavigate={handleNavigation} />;
      // case '/projects':
      //   return <ProjectList projects={localProjects} setProjects={setLocalProjects}  onNavigate={handleNavigation} />;

      case '/projects':
        // Handle /projects with optional query params for employee filtering
        const urlParams = new URLSearchParams(currentPath.split('?')[1] || '');
        const employeeId = urlParams.get('employeeId');
        const employeeName = urlParams.get('employeeName');
        const employeeFilter = employeeId && employeeName ? { id: employeeId, name: employeeName } : null;

        return (
          <ProjectList
            projects={localProjects}
            setProjects={setLocalProjects}
            onNavigate={handleNavigation}
            employeeFilter={employeeFilter}  // Pass filter if present
          />
        );
      case '/add-project':
        return <AddProject onNavigate={handleNavigation} />;

      case '/projects/add':
        return <AddProject onNavigate={handleNavigation} />;

      case '/employees':
        return <EmployeeLists onNavigate={handleNavigation} />;
      case '/kanban':
        return <ProjectTracker projects={localProjects} setProjects={setLocalProjects} milestones={milestones} setMilestones={setMilestones} />;

      case '/project-tasks':
        return <ProjectTasksManagement projects={localProjects} setProjects={setLocalProjects} milestones={milestones} setMilestones={setMilestones} />;


      case '/reports':
        return <Reports projects={localProjects} employees={employees} milestones={milestones} />;
      case '/departments':
        return <Departments />;
      case '/designations':
        return <Designations />;
      // case '/designation':
      //   return <Designation />;
      // case '/role-permissions':
      //   return <RolePermissions />;
      case '/companies':
        return <Companies />;
      case '/franchise':
        return <Franchise />;
      case '/branch':
        return <Branch />;
      case '/subscription':
        return <Subscription />;
      default:
        // Handle /projects/:id path for individual project view
        console.log('Œ FranchiseDashboard - Default case reached, currentPath:', currentPath);
        const projectPathMatch = currentPath.match(/^\/projects\/([^/?]+)/);
        console.log('Regex match result:', projectPathMatch);
        if (projectPathMatch && projectPathMatch[1]) {
          const projectId = projectPathMatch[1];
          console.log('🎯 FranchiseDashboard - Rendering ProjectView with:', {
            currentPath,
            extractedProjectId: projectId,
            localProjectsCount: localProjects?.length,
            foundProject: localProjects?.find(p => String(p._id || p.id) === String(projectId))
          });
          return (
            <ProjectView
              projects={localProjects}
              employees={employees}
              milestones={milestones}
              setMilestones={setMilestones}
              onNavigate={handleNavigation}
              projectId={projectId}
            />
          );
        }
        console.log('❌ No project match - rendering dashboard');
        return renderDashboardContent();
    }
  };



  return (
    <div className="flex h-screen bg-[#F8F9FA]">
      <div className={`bg-[#282a42] shadow-2xl transition-all duration-300 ${isSidebarOpen ? 'w-64' : 'w-20'} border-r border-[#30334e] z-40`}>
        <div className="flex items-center justify-between p-4 border-b border-[#30334e]">
          {isSidebarOpen && (
            <div className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-[#7367F0] rounded-lg flex items-center justify-center shadow-lg">
                <span className="text-white font-bold text-sm">H</span>
              </div>
              <h1 className="text-xl font-bold text-[#d7d8ee]">CRM</h1>
            </div>
          )}
          <button
            onClick={toggleSidebar}
            className="p-2 rounded-lg hover:bg-[#30334e] transition-all duration-200 text-[#d7d8ee] hover:text-white"
          >
            {isSidebarOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        <nav className="mt-4 px-4 pb-4 overflow-y-auto max-h-[calc(100vh-180px)] custom-scrollbar">
          <div className="space-y-1">
            {menuCategories.map((category, index) => (
              <div key={index} className="mb-1">
                {category.submenus.length > 0 ? (
                  <>
                    <button
                      onClick={() => toggleMenu(category.title)}
                      className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${expandedMenus[category.title]
                        ? 'bg-[#7367F0] text-white shadow-lg'
                        : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
                        }`}
                    >
                      <span className={`mr-3 transition-colors duration-200 ${expandedMenus[category.title] ? 'text-white' : 'text-[#b8b9d4]'
                        }`}>
                        {category.icon}
                      </span>

                      {isSidebarOpen && (
                        <>
                          <span className="flex-1 text-left font-medium text-sm">
                            {category.title}
                          </span>
                          <span className={`text-sm transition-transform duration-200 ${expandedMenus[category.title] ? 'rotate-180' : ''
                            }`}>
                            <FiChevronDown />
                          </span>
                        </>
                      )}

                      {expandedMenus[category.title] && (
                        <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
                      )}
                    </button>

                    {isSidebarOpen && expandedMenus[category.title] && (
                      <div className="pl-4 mt-2 space-y-1">
                        {category.submenus.map((submenu, subIndex) => (
                          <button
                            key={subIndex}
                            onClick={() => handleNavigation(submenu.path, submenu.title)}
                            className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl text-sm group ${currentPath === submenu.path
                              ? 'bg-[#3b3d57] text-white shadow-md border-l-2 border-[#7367F0]'
                              : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
                              }`}
                          >
                            <span className={`mr-3 text-sm transition-colors duration-200 ${currentPath === submenu.path ? 'text-[#7367F0]' : 'text-[#b8b9d4]'
                              }`}>
                              {submenu.icon}
                            </span>
                            <span className="font-medium">{submenu.title}</span>

                            {currentPath === submenu.path && (
                              <div className="ml-auto w-2 h-2 bg-[#7367F0] rounded-full"></div>
                            )}
                          </button>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <button
                    onClick={() => handleNavigation(category.path, category.title)}
                    className={`flex items-center w-full p-3 transition-all duration-200 rounded-xl group relative ${currentPath === category.path
                      ? 'bg-[#7367F0] text-white shadow-lg'
                      : 'text-[#d7d8ee] hover:bg-[#30334e] hover:text-white'
                      }`}
                  >
                    <span className={`mr-3 transition-colors duration-200 ${currentPath === category.path ? 'text-white' : 'text-[#b8b9d4]'
                      }`}>
                      {category.icon}
                    </span>

                    {isSidebarOpen && (
                      <span className="font-medium text-sm">{category.title}</span>
                    )}

                    {currentPath === category.path && (
                      <div className="absolute left-0 top-0 bottom-0 w-1 bg-white rounded-r-full"></div>
                    )}
                  </button>
                )}
              </div>
            ))}
          </div>
        </nav>
      </div>

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* TopBar Component */}
        <TopBar
          currentPage={currentPage}
          currentUser={currentUser}
          isProfileDropdownOpen={isProfileDropdownOpen}
          setIsProfileDropdownOpen={setIsProfileDropdownOpen}
          onLogout={handleLogout}
          getUserInitials={getUserInitials}
          onNavigate={handleNavigation}
        />

        <div className="flex-1 overflow-auto p-6">
          {renderPageContent()}
        </div>
      </div>
    </div>
  );
}

export default FranchiseDashboard;

